import { z } from 'zod';
import { BEZEICHNUNGEN_BESTAND, type Bezeichnungen } from '@fameacc/contracts';
import {
  datenregelVorschauAntwortSchema,
  datenregelVorlagenListeSchema,
  datenregelBuchungsvorschauAntwortSchema,
  apiTokenPermissionViewSchema,
  apiTokenSummarySchema,
  appRoleSchema,
  bewegungsfundGrundSchema,
  bewegungsfundSicherheitSchema,
  createdApiTokenSchema,
  anyDocumentTypeSchema,
  createdUserSchema,
  passwordResetSchema,
  documentStatusSchema,
  documentTypeSchema,
  fintsTaktBefundSchema,
  geheimnisformSchema,
  geheimnisformZustandSchema,
  geldkontoAnfangsbestandRichtungSchema,
  geldkontoAnfangsbestandStatusSchema,
  sachkontoSaldenvortragRichtungSchema,
  sachkontoSaldenvortragStatusSchema,
  guthabenAbstimmungBefundklasseSchema,
  guthabenErstattungStatusSchema,
  guthabenErstattungZahlwegSchema,
  guthabenKorrekturBezugSchema,
  guthabenKorrekturGrundSchema,
  guthabenKorrekturRichtungSchema,
  guthabenKorrekturSpiegelSchema,
  guthabenKorrekturStatusSchema,
  istArchivbelegart,
  incomingDocumentDiscardReasonSchema,
  kontenkatalogAntwortSchema,
  kontierungHerkunftSchema,
  kontierungsvorschlagAntwortSchema,
  nichtkontiertGrundSchema,
  portalVorgangSchema,
  priceBasisSchema,
  euB2cStufeSchema,
  taxScenarioSchema,
  userSummarySchema,
  vorsystemFortschrittSchema,
  accountViewSchema as accountViewVertragSchema,
  apiTokenListResponseSchema as apiTokenListResponseVertragSchema,
  apiTokenPermissionListResponseSchema as apiTokenPermissionListResponseVertragSchema,
  journalEntryListResponseSchema as journalEntryListResponseVertragSchema,
  countryListResponseSchema as countryListResponseVertragSchema,
  numberRangeListResponseSchema as numberRangeListResponseVertragSchema,
  duplicateListResponseSchema as duplicateListResponseVertragSchema,
  vatCheckListResponseSchema as vatCheckListResponseVertragSchema,
  documentVersandListResponseSchema as documentVersandListResponseVertragSchema,
  documentListResponseSchema as documentListResponseVertragSchema,
  documentWithoutPdfListResponseSchema as documentWithoutPdfListResponseVertragSchema,
  numberRangeReportListResponseSchema as numberRangeReportListResponseVertragSchema,
  issuerProfileListResponseSchema as issuerProfileListResponseVertragSchema,
  bankAccountListResponseSchema as bankAccountListResponseVertragSchema,
  bankStatementListResponseSchema as bankStatementListResponseVertragSchema,
  tabellenansichtAntwortSchema as tabellenansichtAntwortVertragSchema,
  sachkontoPraeferenzenAntwortSchema as sachkontoPraeferenzenAntwortVertragSchema,
  guthabenAbstimmungListeSchema as guthabenAbstimmungListeVertragSchema,
  guthabenErstattungWartendListeSchema as guthabenErstattungWartendListeVertragSchema,
  guthabenSchalterSchema as guthabenSchalterVertragSchema,
  guthabenKorrekturListeSchema as guthabenKorrekturListeVertragSchema,
  guthabenKorrekturSpiegelOffenListeSchema as guthabenKorrekturSpiegelOffenListeVertragSchema,
  accountListResponseSchema as accountListResponseVertragSchema,
  continuityBreakSchema as continuityBreakVertragSchema,
  coverageGapSchema as coverageGapVertragSchema,
  customerListResponseSchema as customerListResponseVertragSchema,
  meResponseSchema as meResponseVertragSchema,
  nichttreffergruppeSchema as nichttreffergruppeVertragSchema,
  paymentServiceCoverageSchema as paymentServiceCoverageVertragSchema,
  paymentWindowSchema as paymentWindowVertragSchema,
  periodListResponseSchema as periodListResponseVertragSchema,
  userListResponseSchema as userListResponseVertragSchema,
  vendorListResponseSchema as vendorListResponseVertragSchema,
  accountWarningSchema as accountWarningVertragSchema,
  accountWriteResultSchema as accountWriteResultVertragSchema,
  ausbeuteBerichtSchema as ausbeuteBerichtVertragSchema,
  ausbeutezahlenSchema as ausbeutezahlenVertragSchema,
  auswertungAltersbandSchema as auswertungAltersbandVertragSchema,
  auswertungAnteilSchema as auswertungAnteilVertragSchema,
  auswertungForderungenSchema as auswertungForderungenVertragSchema,
  auswertungGuthabenMonatSchema as auswertungGuthabenMonatVertragSchema,
  auswertungMonatsreiheSchema as auswertungMonatsreiheVertragSchema,
  auswertungUeberblickSchema as auswertungUeberblickVertragSchema,
  auswertungUnterseiteSchema as auswertungUnterseiteVertragSchema,
  auswertungZahlungswegeSchema as auswertungZahlungswegeVertragSchema,
  auswertungZeitraumSchema as auswertungZeitraumVertragSchema,
  bankAccountSchema as bankAccountVertragSchema,
  bankRueckmeldungEintragSchema as bankRueckmeldungEintragVertragSchema,
  bankStatementSchema as bankStatementVertragSchema,
  bankTransactionListSchema as bankTransactionListVertragSchema,
  bankTransactionSchema as bankTransactionVertragSchema,
  belegExtractionSchema as belegExtractionVertragSchema,
  bestehendeVerknuepfungSchema as bestehendeVerknuepfungVertragSchema,
  bewegungskandidatSchema as bewegungskandidatVertragSchema,
  bewegungsstandAntwortSchema as bewegungsstandAntwortVertragSchema,
  bewegungsstandBewegungSchema as bewegungsstandBewegungVertragSchema,
  bewegungssucheAntwortSchema as bewegungssucheAntwortVertragSchema,
  billingAddressViewSchema as billingAddressViewVertragSchema,
  countryViewSchema as countryViewVertragSchema,
  coverageReportSchema as coverageReportVertragSchema,
  customerLinkViewSchema as customerLinkViewVertragSchema,
  customerViewSchema as customerViewVertragSchema,
  datenregelFassungAntwortSchema as datenregelFassungAntwortVertragSchema,
  datenregelFassungZeileSchema as datenregelFassungZeileVertragSchema,
  datenregelnListeSchema as datenregelnListeVertragSchema,
  datenregelZeileSchema as datenregelZeileVertragSchema,
  documentLineViewSchema as documentLineViewVertragSchema,
  documentSummarySchema as documentSummaryVertragSchema,
  documentTaxGroupViewSchema as documentTaxGroupViewVertragSchema,
  documentVersandEntrySchema as documentVersandEntryVertragSchema,
  documentVersandEntwurfSchema as documentVersandEntwurfVertragSchema,
  documentViewSchema as documentViewVertragSchema,
  documentWithoutPdfViewSchema as documentWithoutPdfViewVertragSchema,
  duplicateCandidateListSchema as duplicateCandidateListVertragSchema,
  duplicateCandidateSchema as duplicateCandidateVertragSchema,
  duplicateEntrySchema as duplicateEntryVertragSchema,
  eingangsrechnungZahlstandSchema as eingangsrechnungZahlstandVertragSchema,
  eingangsrechnungZahlstatusSchema as eingangsrechnungZahlstatusVertragSchema,
  euB2cSchwelleSchema as euB2cSchwelleVertragSchema,
  fassungLageSchema as fassungLageVertragSchema,
  fetchContinuityBreakSchema as fetchContinuityBreakVertragSchema,
  fetchListSchema as fetchListVertragSchema,
  fetchReportSchema as fetchReportVertragSchema,
  fetchWindowListSchema as fetchWindowListVertragSchema,
  fintsAbrufBerichtSchema as fintsAbrufBerichtVertragSchema,
  fintsBankRueckmeldungSchema as fintsBankRueckmeldungVertragSchema,
  fintsDrahtNachrichtSchema as fintsDrahtNachrichtVertragSchema,
  fintsEinrichtungSchema as fintsEinrichtungVertragSchema,
  fintsInstitutListeSchema as fintsInstitutListeVertragSchema,
  fintsInstitutSchema as fintsInstitutVertragSchema,
  fintsLaufSchema as fintsLaufVertragSchema,
  fintsSaldoAbgleichSchema as fintsSaldoAbgleichVertragSchema,
  fintsTanMedienAbrufSchema as fintsTanMedienAbrufVertragSchema,
  fintsZugangstestSchema as fintsZugangstestVertragSchema,
  fintsZugangstestVerfahrenSchema as fintsZugangstestVerfahrenVertragSchema,
  fintsZugangTanVerfahrenSchema as fintsZugangTanVerfahrenVertragSchema,
  formatReportSchema as formatReportVertragSchema,
  formklassenSchema as formklassenVertragSchema,
  gapReportSchema as gapReportVertragSchema,
  gapSchema as gapVertragSchema,
  geldkontoAnfangsbestandFreigabeAntwortSchema as geldkontoAnfangsbestandFreigabeAntwortVertragSchema,
  geldkontoAnfangsbestandListeSchema as geldkontoAnfangsbestandListeVertragSchema,
  geldkontoAnfangsbestandZeileSchema as geldkontoAnfangsbestandZeileVertragSchema,
  gleichung1BerichtSchema as gleichung1BerichtVertragSchema,
  gleichung1KomponenteSchema as gleichung1KomponenteVertragSchema,
  guthabenAbstimmungBefundSchema as guthabenAbstimmungBefundVertragSchema,
  guthabenAbstimmungDetailSchema as guthabenAbstimmungDetailVertragSchema,
  guthabenAbstimmungListItemSchema as guthabenAbstimmungListItemVertragSchema,
  guthabenEinloesungSchema as guthabenEinloesungVertragSchema,
  guthabenEinloesungStornoSchema as guthabenEinloesungStornoVertragSchema,
  guthabenErstattungSchema as guthabenErstattungVertragSchema,
  guthabenKorrekturKetteSchema as guthabenKorrekturKetteVertragSchema,
  guthabenKorrekturSchema as guthabenKorrekturVertragSchema,
  guthabenKorrekturSpiegelOffenSchema as guthabenKorrekturSpiegelOffenVertragSchema,
  incomingCaptureResultSchema as incomingCaptureResultVertragSchema,
  incomingDocumentDiscardSchema as incomingDocumentDiscardVertragSchema,
  incomingDocumentSchema as incomingDocumentVertragSchema,
  incomingInvoiceDetailSchema as incomingInvoiceDetailVertragSchema,
  incomingInvoiceListSchema as incomingInvoiceListVertragSchema,
  incomingInvoiceSchema as incomingInvoiceVertragSchema,
  incomingKorbListeSchema as incomingKorbListeVertragSchema,
  incomingKorbvorschlagSchema as incomingKorbvorschlagVertragSchema,
  incomingKorbzeileSchema as incomingKorbzeileVertragSchema,
  incomingPrefillSchema as incomingPrefillVertragSchema,
  incomingTaxLineSchema as incomingTaxLineVertragSchema,
  incomingUploadResultSchema as incomingUploadResultVertragSchema,
  issuerBankAccountViewSchema as issuerBankAccountViewVertragSchema,
  issueResultSchema as issueResultVertragSchema,
  issuerProfileViewSchema as issuerProfileViewVertragSchema,
  journalEntryDetailSchema as journalEntryDetailVertragSchema,
  journalEntryViewSchema as journalEntryViewVertragSchema,
  journalLineViewSchema as journalLineViewVertragSchema,
  kontierungAutomatischListeSchema as kontierungAutomatischListeVertragSchema,
  kontierungAutomatischZeileSchema as kontierungAutomatischZeileVertragSchema,
  kontierungPositionSchema as kontierungPositionVertragSchema,
  kontierungSchema as kontierungVertragSchema,
  kontierungWartendListeSchema as kontierungWartendListeVertragSchema,
  kontierungWartendZeileSchema as kontierungWartendZeileVertragSchema,
  kontoblattSchema as kontoblattVertragSchema,
  kontoblattZeileSchema as kontoblattZeileVertragSchema,
  kundenakteSchema as kundenakteVertragSchema,
  lastschriftEinreichungLaufSchema as lastschriftEinreichungLaufVertragSchema,
  legacyDunningViewSchema as legacyDunningViewVertragSchema,
  linkViewSchema as linkViewVertragSchema,
  messzahlenSchema as messzahlenVertragSchema,
  numberGapDetailSchema as numberGapDetailVertragSchema,
  numberGapViewSchema as numberGapViewVertragSchema,
  numberRangeReportRowSchema as numberRangeReportRowVertragSchema,
  numberRangeViewSchema as numberRangeViewVertragSchema,
  offenePostenBelegSchema as offenePostenBelegVertragSchema,
  offenePostenBerichtSchema as offenePostenBerichtVertragSchema,
  offenePostenKundeSchema as offenePostenKundeVertragSchema,
  offenePostenUeberfaelligSchema as offenePostenUeberfaelligVertragSchema,
  periodViewSchema as periodViewVertragSchema,
  priceBasisChangeResultSchema as priceBasisChangeResultVertragSchema,
  priceBasisWarningSchema as priceBasisWarningVertragSchema,
  probeResultSchema as probeResultVertragSchema,
  rechnungBewegungAntwortSchema as rechnungBewegungAntwortVertragSchema,
  rechnungBewegungTrefferSchema as rechnungBewegungTrefferVertragSchema,
  rechnungZahlstandSchema as rechnungZahlstandVertragSchema,
  rechnungZahlstatusSchema as rechnungZahlstatusVertragSchema,
  rechnungZahlungSchema as rechnungZahlungVertragSchema,
  regelUebersichtSchema as regelUebersichtVertragSchema,
  regelUebersichtZeileSchema as regelUebersichtZeileVertragSchema,
  regelZaehlungSchema as regelZaehlungVertragSchema,
  sachkontoSaldenvortragAnlageAntwortSchema as sachkontoSaldenvortragAnlageAntwortVertragSchema,
  sachkontoSaldenvortragFreigabeAntwortSchema as sachkontoSaldenvortragFreigabeAntwortVertragSchema,
  sachkontoSaldenvortragKontoSchema as sachkontoSaldenvortragKontoVertragSchema,
  sachkontoSaldenvortragListeSchema as sachkontoSaldenvortragListeVertragSchema,
  sachkontoSaldenvortragZeileSchema as sachkontoSaldenvortragZeileVertragSchema,
  stageResponseSchema as stageResponseVertragSchema,
  startkennzahlenBerichtSchema as startkennzahlenBerichtVertragSchema,
  startkennzahlenZeitraumSchema as startkennzahlenZeitraumVertragSchema,
  statementImportBatchResultSchema as statementImportBatchResultVertragSchema,
  statementImportResultSchema as statementImportResultVertragSchema,
  systemStatusSchema as systemStatusVertragSchema,
  teilzahlungBewegungSchema as teilzahlungBewegungVertragSchema,
  teilzahlungListeSchema as teilzahlungListeVertragSchema,
  totpEnrollmentSchema as totpEnrollmentVertragSchema,
  uebersprungenesFensterSchema as uebersprungenesFensterVertragSchema,
  unbookedReportSchema as unbookedReportVertragSchema,
  unkontierteListeSchema as unkontierteListeVertragSchema,
  vatCheckViewSchema as vatCheckViewVertragSchema,
  vatStatusSchema as vatStatusVertragSchema,
  vendorErkennungListeSchema as vendorErkennungListeVertragSchema,
  vendorErkennungRegelSchema as vendorErkennungRegelVertragSchema,
  vendorViewSchema as vendorViewVertragSchema,
  verbindlichkeitZahlstatusAntwortSchema as verbindlichkeitZahlstatusAntwortVertragSchema,
  verbindlichkeitZahlstatusListeSchema as verbindlichkeitZahlstatusListeVertragSchema,
  verbindlichkeitZahlungSchema as verbindlichkeitZahlungVertragSchema,
  zahlstatusAntwortSchema as zahlstatusAntwortVertragSchema,
  zahlstatusListeSchema as zahlstatusListeVertragSchema,
  zugangsprobeSchema as zugangsprobeVertragSchema,
  zugangspunktSchema as zugangspunktVertragSchema,
  zuordnungsquoteBerichtSchema as zuordnungsquoteBerichtVertragSchema,
} from '@fameacc/contracts';

/**
 * Entfernt die Typmarken der Geldtypen (`Money`, `Factor`) aus einem Typ — tief,
 * durch Objekte, Listen und `null`/`undefined` hindurch.
 *
 * **Warum.** Die Vertragsschemas in `@fameacc/contracts` geben Beträge als
 * `Money` zurück (`centAmount`, geprüft und kanonisiert). Die Marke existiert
 * nur zur Übersetzungszeit; im Browser bringt sie nichts, kostet aber an jeder
 * Stelle, die eine Antwort von Hand baut — vor allem in den Testdaten — ein
 * `as Money`. Die Oberfläche liest und zeigt Beträge, sie rechnet sie nicht
 * (Hausregel 1: nie `number`, sie bleiben Zeichenketten).
 *
 * Erkannt wird eine Marke daran, dass ein Zeichenkettentyp mehr Schlüssel
 * trägt als `string` selbst; Wertelisten (`'a' | 'b'`) und blosse
 * `string` bleiben unberührt. Keine Importe aus `@fameacc/money` nötig.
 */
export type OhneMarken<T> = T extends string
  ? [Exclude<keyof T, keyof string>] extends [never]
    ? T
    : string
  : T extends readonly unknown[]
    ? { [K in keyof T]: OhneMarken<T[K]> }
    : T extends object
      ? { [K in keyof T]: OhneMarken<T[K]> }
      : T;

/**
 * Das Vertragsschema, wie die Oberfläche es liest: zur Laufzeit dasselbe
 * Objekt, im Typ ohne Geldmarken.
 *
 * **Das ist die eine Regel für jedes Schema in `schemas.ts`, das der Vertrag
 * kennt:** nichts nachschreiben, sondern den Vertrag benutzen (Handbuch
 * §3.958). Ein nachgeschriebenes `z.object` verliert still jedes Feld, das der
 * Vertrag später bekommt; ein Vertragsschema lehnt es laut ab oder kennt es.
 * Der Wächter dazu ist `pnpm web:schemas`.
 *
 * Zur Laufzeit ändert diese Funktion nichts: kein Umweg, keine zweite
 * Prüfung, die Umwandlung der Beträge im Vertrag (`centAmount`) läuft
 * unverändert. Wer das Schema erweitern will, erweitert das Vertragsschema
 * und ruft diese Funktion auf das Ergebnis auf.
 */
export function ohneMarken<S extends z.ZodTypeAny>(
  schema: S,
): z.ZodType<OhneMarken<z.output<S>>, z.ZodTypeDef, z.input<S>> {
  return schema;
}

/**
 * Die Antwortformen der API, wie das Frontend sie liest.
 *
 * **Warum geprüft und nicht bloss behauptet.** Ein `await response.json() as
 * JournalEntry[]` ist eine Behauptung über fremde Daten. Sie hält genau so
 * lange, bis ein Feld umbenannt wird — und fällt dann nicht an der Grenze auf,
 * sondern irgendwo tief in einer Tabellenzelle als `undefined`. Die Schemas
 * hier sind die Grenze; was sie nicht kennen, kommt gar nicht erst in die
 * Anzeige.
 *
 * **Warum sie in `@fameacc/contracts` stehen.** Dort stehen die
 * Verträge der *Fachanfragen* — Buchung und Storno. Antwortformen gehören
 * dorthin, sobald ein zweiter Leser sie braucht: Der OpenAPI-Erzeuger
 * ist seit Phase 2 ein solcher Leser.
 *
 * **Was der Vertrag kennt, wird benutzt und nicht nachgeschrieben**
 * (`W-schemasabschriften`, Handbuch §3.958): `ohneMarken(vertragsschema)` ist
 * zur Laufzeit dasselbe Objekt, im Typ nur ohne die Geldmarken (`Money`,
 * `Factor`), die im Browser nichts bringen. Ein nachgeschriebenes `z.object`
 * verlor still jedes Feld, das der Vertrag später bekam — `pnpm web:schemas`
 * weist es ab. Hier selbst stehen nur Formen ohne Vertragsgegenstück,
 * Umschläge um importierte Elementschemas und Ableitungen.
 *
 * **Beträge bleiben Zeichenketten.** Sie werden nie in eine Zahl umgewandelt —
 * das ist die Grundregel des Systems und gilt im Browser genauso wie im
 * Dienst.
 *
 * **Die WERTELISTEN der `z.enum(...)`-Felder stehen dagegen nicht hier,
 * sondern werden aus `@fameacc/contracts` importiert.** Eine Liste, die von
 * Hand ein zweites Mal abgeschrieben wird, veraltet lautlos: `extractionSource`
 * bekam in Migration `0057` den Wert `structured_xml`, der Vertrag führte ihn
 * sofort, und diese Datei musste von Hand nachgezogen werden — bis dahin
 * lehnte die Oberfläche jeden neu erfassten Beleg mit dieser Herkunft ab, ohne
 * dass ein Test es gemeldet hätte. Ein Feld, dessen Wertevorrat der Vertrag
 * bereits führt, importiert ihn; wer ihn erneut aufzählt, hat einen Fehler
 * eingebaut, keine Abkürzung genommen. Nur echte Web-only-Aufzählungen — ohne
 * Entsprechung im Vertrag, etwa der Sitzungsstatus — bleiben lokal und tragen
 * dafür einen eigenen Kommentar.
 */

export {
  anyDocumentTypeSchema,
  documentTypeSchema,
  documentStatusSchema,
  priceBasisSchema,
  taxScenarioSchema,
};

/** Ein Betrag, wie ihn die API liefert: `numeric(15,2)` als Zeichenkette. */
const betragSchema = z.string();

/**
 * Eine Antwort ohne Inhalt — für die Endpunkte, die `204` liefern.
 *
 * `request<T>()` prüft **jede** Antwort gegen ein Schema; ein leerer Rumpf wird
 * dort zu `{}`. Ein eigenes Schema dafür ist besser als eine Ausnahme in der
 * Hilfe: Die Ausnahme gälte dann auch für die Endpunkte, die etwas liefern
 * sollten und es vergessen haben.
 */
export const ohneInhaltSchema = z.object({}).passthrough();

export const stageSchema = ohneMarken(stageResponseVertragSchema);

/** Die drei Zustände der Anmeldekette. Dieselbe Reihenfolge wie in `pre-session.ts`. */
export const preSessionStates = [
  'awaiting_password_change',
  'awaiting_totp_enroll',
  'awaiting_totp',
] as const;

/** Ein Zustand der Anmeldekette. */
export type PreSessionState = (typeof preSessionStates)[number];

/** Ist die Zeichenkette einer der drei Zustände? */
export function isPreSessionState(value: string | undefined): value is PreSessionState {
  return value !== undefined && (preSessionStates as readonly string[]).includes(value);
}

/** Das Ergebnis einer Anmeldestufe. */
export type Stage = z.infer<typeof stageSchema>;

export const totpEnrollmentSchema = ohneMarken(totpEnrollmentVertragSchema);

/** Was `POST /auth/totp/enroll` liefert. */
export type TotpEnrollment = z.infer<typeof totpEnrollmentSchema>;

/**
 * Wer angemeldet ist und was er darf.
 *
 * **Die drei Sperrfelder sind optional, und das ist kein Nachlassen**
 * (`A-sitzungssperre`). Ein Pflichtfeld `locked` machte diese Antwort
 * unlesbar, sobald die Oberfläche einmal vor der API steht — genau der Fall,
 * den `RESPONSE_UNREADABLE` in `client.ts` als harten Fehler behandelt, und
 * der Anwender sähe statt der Anmeldemaske eine Formmeldung. `locked === true`
 * ist die Frage, die jede Stelle stellt; alles andere heisst «offen».
 *
 * `gesperrtSeit` und `geraet` stehen NUR in der gesperrten Antwort — der
 * Server schickt sie sonst gar nicht mit.
 *
 * **Die Form kommt aus dem Vertrag** (`meResponseSchema`, `W-fehlendevertraege`,
 * Handbuch §3.969); hier wird allein `locked` gelockert. Der Server schickt es
 * immer — die Lockerung gilt der Oberfläche vor einem Server, der es noch nicht
 * kannte.
 */
export const meSchema = ohneMarken(meResponseVertragSchema.extend({ locked: z.boolean().optional() }));

/** Der angemeldete Benutzer. */
export type Me = z.infer<typeof meSchema>;

/**
 * Die Benutzerverwaltung — `GET /api/v1/users`, `POST /api/v1/users`.
 *
 * `userSummarySchema`/`createdUserSchema`/`appRoleSchema` kommen aus
 * `@fameacc/contracts` und werden hier nicht neu geschrieben (dieselbe
 * Regel wie überall in dieser Datei, siehe Kopfkommentar). Nur die Listenhülle
 * und die deutsche Beschriftung der vier Rollen sind web-only.
 */
export type User = z.infer<typeof userSummarySchema>;

/** Das Ergebnis von `POST /api/v1/users` — das Einmalpasswort erscheint nur hier. */
export type CreatedUser = z.infer<typeof createdUserSchema>;

/** Das Ergebnis von `POST /api/v1/users/:id/password/reset` — das neue Einmalpasswort erscheint nur hier. */
export type PasswordReset = z.infer<typeof passwordResetSchema>;

/** Die Benutzerliste. */
export const userListSchema = ohneMarken(userListResponseVertragSchema);

/** Eine der vier Rollen aus `app_role`. */
export type AppRole = z.infer<typeof appRoleSchema>;

/** Die vier Rollen, in der Reihenfolge des Vertrags — für das Auswahlfeld im Anlegen-Dialog. */
export const APP_ROLES = appRoleSchema.options;

/** Die deutschen Namen der vier Rollen. */
export const APP_ROLE_LABEL: Readonly<Record<AppRole, string>> = {
  admin: 'Administrator',
  accountant: 'Buchhalter',
  reviewer: 'Prüfer',
  readonly: 'Nur lesen',
};


/** Alias für das Namensverzeichnis (`W-namensanzeige`): derselbe Vertragstyp. */
export type UserSummary = User;

/**
 * Die API-Tokens — `GET /api/v1/apitokens`, `POST /api/v1/apitokens`
 * (Auftrag `W-apitoken-ui`, 2026-09-01).
 *
 * `apiTokenSummarySchema`/`createdApiTokenSchema`/`apiTokenPermissionViewSchema`
 * kommen seit `C-tokenvertrag` (2026-09-01) aus `@fameacc/contracts` und
 * werden hier nicht neu geschrieben (dieselbe Regel wie überall in dieser
 * Datei, siehe Kopfkommentar, und derselbe Vertragsumzug, den
 * `users.service.ts` mit `V-vertrag3` schon durchlief). Nur die Listenhülle
 * ist web-only.
 */
export type ApiToken = z.infer<typeof apiTokenSummarySchema>;

/** Eine Endpunktberechtigung eines Tokens, mit ihren Verwaltungsangaben. */
export type ApiTokenPermission = z.infer<typeof apiTokenPermissionViewSchema>;

/** Die Tokenliste. */
export const apiTokenListSchema = ohneMarken(apiTokenListResponseVertragSchema);

/**
 * Die Antwort von `PUT /api/v1/apitokens/:id/permissions` — die Hülle kommt wie
 * `apiTokenListSchema` oben aus dem Vertrag (`apiTokenPermissionListResponseSchema`,
 * Handbuch §3.969).
 */
export const apiTokenPermissionsResponseSchema = ohneMarken(apiTokenPermissionListResponseVertragSchema);

/** Das einmalige Ergebnis der Tokenanlage — der Tokenwert erscheint nur hier. */
export type CreatedApiToken = z.infer<typeof createdApiTokenSchema>;

/**
 * Die Schnittstellenbeschreibung, soweit die Endpunktauswahl sie braucht —
 * `GET /api/docs/openapi.json` (`apps/api/src/openapi/docs.controller.ts`).
 *
 * **Nur vier Angaben je Operation, und der Rest wird verworfen.** Das Dokument
 * ist rund ein Megabyte gross; alles daran ausser Pfad, Methode, `tags`,
 * `summary` und `x-fameacc-zugriff` interessiert diese Oberfläche nicht, und
 * ein Schema ohne `passthrough()` wirft es beim Prüfen weg, statt es im
 * Speicher zu halten. Was hier fehlt, kommt gar nicht erst in die Anzeige —
 * dieselbe Grundregel wie bei jeder anderen Antwortform dieser Datei.
 */
export const schnittstellenbeschreibungSchema = z.object({
  paths: z.record(
    z.record(
      z.object({
        tags: z.array(z.string()).optional(),
        summary: z.string().optional(),
        'x-fameacc-zugriff': z.string().optional(),
        // Sitzungsgebundene Routen (Datensicherungs-Spec 8.1, `D-55`): Ohne
        // dieses Feld verwürfe das Schema die Markierung, bevor
        // `apitokens/endpunkte.ts` sie sieht, und der Token-Dialog böte eine
        // Route an, deren Vergabe der Server mit 422 abweist.
        'x-fameacc-sitzungsgebunden': z.boolean().optional(),
      }),
    ),
  ),
});

/** Die Schnittstellenbeschreibung, auf das Nötige beschnitten. */
export type Schnittstellenbeschreibung = z.infer<typeof schnittstellenbeschreibungSchema>;
export const journalEntrySchema = ohneMarken(journalEntryViewVertragSchema);

/** Eine Buchung, wie die Liste sie zeigt. */
export type JournalEntry = z.infer<typeof journalEntrySchema>;

export const journalLineSchema = ohneMarken(journalLineViewVertragSchema);

/** Eine Buchungszeile. */
export type JournalLine = z.infer<typeof journalLineSchema>;

export const journalEntryDetailSchema = ohneMarken(journalEntryDetailVertragSchema);

/** Eine Buchung samt Zeilen. */
export type JournalEntryDetail = z.infer<typeof journalEntryDetailSchema>;

/** Die Buchungsliste. */
export const journalListSchema = ohneMarken(journalEntryListResponseVertragSchema);

export const periodSchema = ohneMarken(periodViewVertragSchema);

/** Eine Periode. */
export type Period = z.infer<typeof periodSchema>;

/** Die Periodenliste. */
export const periodListSchema = ohneMarken(periodListResponseVertragSchema);

export const accountSchema = ohneMarken(accountViewVertragSchema);

/** Eine Kontoversion. */
export type Account = z.infer<typeof accountSchema>;

/** Der Kontenrahmen. */
export const accountListSchema = ohneMarken(accountListResponseVertragSchema);

export const accountWarningSchema = ohneMarken(accountWarningVertragSchema);

/** Eine Warnung der Kontenstrecke. */
export type AccountWarning = z.infer<typeof accountWarningSchema>;

export const accountWriteResultSchema = ohneMarken(accountWriteResultVertragSchema);

/** Das Ergebnis einer Anlage oder Neuversionierung. */
export type AccountWriteResult = z.infer<typeof accountWriteResultSchema>;

/** Die deutschen Bezeichnungen der Kontenarten. */
export const KONTOART: Readonly<Record<Account['type'], string>> = {
  asset: 'Aktiva',
  liability: 'Passiva',
  equity: 'Eigenkapital',
  revenue: 'Ertrag',
  expense: 'Aufwand',
};

/**
 * Die Bezeichnung einer Kontenart, auch wenn die Antwort sie als blosse
 * Zeichenkette fuehrt (das Kontoblatt tut das im Vertrag): eine unbekannte Art
 * erscheint unuebersetzt, statt die Seite zu brechen.
 */
export function kontoartBezeichnung(art: string): string {
  const bezeichnungen: Readonly<Record<string, string | undefined>> = KONTOART;
  return bezeichnungen[art] ?? art;
}

/**
 * Das Gegenkonto einer Kontoblattzeile — genau eines, oder ehrlich «mehrere».
 *
 * `art: 'einzeln'` trägt Nummer und Name der einen Gegenzeile; `art: 'mehrere'`
 * nennt nur die Anzahl. Ein erfundenes Einzelgegenkonto bei einem mehrzeiligen
 * Satz wäre eine Behauptung, die die Buchung nicht macht.
 */
export const kontoblattGegenkontoSchema = z.discriminatedUnion('art', [
  z.object({ art: z.literal('einzeln'), number: z.string(), name: z.string() }),
  z.object({ art: z.literal('mehrere'), anzahl: z.number() }),
]);

/** Das Gegenkonto einer Kontoblattzeile. */
export type KontoblattGegenkonto = z.infer<typeof kontoblattGegenkontoSchema>;

export const kontoblattZeileSchema = ohneMarken(kontoblattZeileVertragSchema);

/** Eine Kontoblattzeile. */
export type KontoblattZeile = z.infer<typeof kontoblattZeileSchema>;

export const kontoblattSchema = ohneMarken(kontoblattVertragSchema);

/** Das Kontoblatt. */
export type Kontoblatt = z.infer<typeof kontoblattSchema>;

// --- Phase 2: Stammdaten --------------------------------------------------

export const countrySchema = ohneMarken(countryViewVertragSchema);

/** Ein Land. */
export type Country = z.infer<typeof countrySchema>;

/** Die Länderliste. */
export const countryListSchema = ohneMarken(countryListResponseVertragSchema);

export const numberRangeSchema = ohneMarken(numberRangeViewVertragSchema);

/** Ein Nummernkreis. */
export type NumberRange = z.infer<typeof numberRangeSchema>;

/** Die Nummernkreise. */
export const numberRangeListSchema = ohneMarken(numberRangeListResponseVertragSchema);

export const vatStatusSchema = ohneMarken(vatStatusVertragSchema);

/** Der Prüfstand der USt-IdNr. */
export type VatStatus = z.infer<typeof vatStatusSchema>;

export const customerLinkSchema = ohneMarken(customerLinkViewVertragSchema);

/** Eine offene Verknüpfung am Kundensatz. */
export type CustomerLink = z.infer<typeof customerLinkSchema>;

export const customerSchema = ohneMarken(customerViewVertragSchema);

/** Ein Kunde. */
export type Customer = z.infer<typeof customerSchema>;

/**
 * Die Antwort von `GET /customers/:id`.
 *
 * Dieselbe Form wie ein Listeneintrag — der Endpunkt liefert `CustomerView`,
 * und die Liste liefert dieselbe Ansicht samt `openLinks`. Der eigene Name
 * steht hier, damit an der Aufrufstelle sichtbar bleibt, welcher Endpunkt
 * gemeint ist; ein zweites Schema wäre eine zweite Behauptung über dieselbe
 * Antwort.
 */
export const customerDetailSchema = customerSchema;

export const kundenakteSchema = ohneMarken(kundenakteVertragSchema);

/** Umsatz und offene Posten eines Kunden. */
export type Kundenakte = z.infer<typeof kundenakteSchema>;

/** Der Umsatz eines Kalenderjahres in der Kundenakte. */
export type KundenakteUmsatzJahr = Kundenakte['umsatzJahre'][number];

/** Die Kundenliste. */
export const customerListSchema = ohneMarken(customerListResponseVertragSchema);

/**
 * Ein Kandidat, wie ihn die Ablehnung `CUSTOMER_DUPLICATE_SUSPECTED` nennt.
 *
 * Er steht im Fehlerkörper unter `error.candidates` und trägt genau die
 * Kriterien, die der Abgleich getroffen hat — nicht die, die der Aufrufer
 * gesehen zu haben behauptet.
 */
export const kundenDublettenkandidatSchema = z.object({
  customerId: z.string(),
  displayCustomerNo: z.string(),
  legalName: z.string(),
  matchedCriteria: z.array(z.string()),
});

/** Ein gemeldeter Kandidat. */
export type DuplicateCandidate = z.infer<typeof kundenDublettenkandidatSchema>;

/** Der Fehlerkörper der vermuteten Dublette, soweit die Maske ihn braucht. */
export const duplicateDetailsSchema = z.object({
  candidates: z.array(kundenDublettenkandidatSchema),
});

export const linkSchema = ohneMarken(linkViewVertragSchema);

/** Eine Verknüpfung zweier Kundensätze. */
export type Link = z.infer<typeof linkSchema>;

export const duplicateEntrySchema = ohneMarken(duplicateEntryVertragSchema);

/** Ein Eintrag des Arbeitsvorrats. */
export type DuplicateEntry = z.infer<typeof duplicateEntrySchema>;

/** Der Arbeitsvorrat. */
export const duplicateListSchema = ohneMarken(duplicateListResponseVertragSchema);

export const vatCheckSchema = ohneMarken(vatCheckViewVertragSchema);

/** Eine aufgezeichnete Prüfung. */
export type VatCheck = z.infer<typeof vatCheckSchema>;

/** Die Prüfhistorie. */
export const vatCheckListSchema = ohneMarken(vatCheckListResponseVertragSchema);

export const vendorSchema = ohneMarken(vendorViewVertragSchema);

/** Ein Kreditor. */
export type Vendor = z.infer<typeof vendorSchema>;

/** Eine Erkennungsregel eines Kreditors. */
export const vendorErkennungRegelSchema = ohneMarken(vendorErkennungRegelVertragSchema);

/** Eine Erkennungsregel eines Kreditors. */
export type VendorErkennungRegel = z.infer<typeof vendorErkennungRegelSchema>;

/** Die Erkennungsregeln eines Kreditors. */
export const vendorErkennungListeSchema = ohneMarken(vendorErkennungListeVertragSchema);

/** Die Antwort von `GET /vendors/:id`. Dieselbe Form wie ein Listeneintrag. */
export const vendorDetailSchema = vendorSchema;

/** Die Kreditorenliste. */
export const vendorListSchema = ohneMarken(vendorListResponseVertragSchema);

/** Ein gleichnamiger Kreditor, wie ihn `VENDOR_SIMILAR_EXISTS` nennt. */
export const similarVendorSchema = z.object({
  vendorId: z.string(),
  creditorNo: z.string(),
  legalName: z.string(),
});

/** Ein gleichnamiger Kreditor. */
export type SimilarVendor = z.infer<typeof similarVendorSchema>;

/** Der Fehlerkörper der Ähnlichkeitswarnung, soweit die Maske ihn braucht. */
export const similarDetailsSchema = z.object({ similar: z.array(similarVendorSchema) });

/**
 * Das Quellsystem eines über die Oberfläche erfassten Stammsatzes.
 *
 * `source_system` beantwortet «aus welchem System stammt dieser Satz». Für
 * einen hier getippten Satz ist die Antwort diese Anwendung; der Import
 * schreibt an derselben Stelle `fa_rechnungen`, und der Unterschied ist genau
 * der, den ein Prüfer wissen will. Beide Masken benutzen denselben Wert — zwei
 * Schreibweisen desselben Systems wären zwei Systeme in der Auswertung.
 */
export const QUELLSYSTEM = 'fameaccounting';

// --- Die deutschen Bezeichnungen ------------------------------------------

/**
 * Die Dublettenkriterien in Klartext.
 *
 * Ein Prüfer bekommt `name_address` nicht zu sehen. Die vier Schlüssel stehen
 * genau so im Trigger aus Migration 0017 und in `customer.query.ts`; die
 * Übersetzung gehört an die Oberfläche und nicht in die Daten.
 */
export const KRITERIUM: Readonly<Record<string, string>> = {
  vat_id: 'USt-IdNr.',
  email: 'E-Mail',
  name_address: 'Name und Anschrift',
  address: 'Anschrift',
};

/**
 * Die Herkunft eines Kundensatzes.
 *
 * `altsystem` ist die Herkunft der Kunden, die die Übernahme der
 * Bestandsrechnungen mitbringt — der eigene Stamm des Vorgängersystems. Sie
 * erscheint in der Liste und im Filter, kann aber über die Maske nicht gewählt
 * werden: Wer einen Kunden anlegt, legt ihn in diesem System an. Dasselbe gilt
 * für `vorsystem` — Kunden, die die Übernahme aus einem Vorsystem (Lexware
 * Office) mitbringt.
 */
export const HERKUNFT: Readonly<Record<Customer['origin'], string>> = {
  famesystems: BEZEICHNUNGEN_BESTAND.webkundeHerkunftBezeichnung,
  manual: 'Buchhaltung',
  altsystem: 'Altsystem',
  vorsystem: 'Vorsystem',
};

/**
 * Die Herkunftsbezeichnungen mit dem Namen der Installation — die Herkunft
 * `famesystems` heisst so, wie `betrieb_einstellung.webkunde_herkunft_bezeichnung`
 * sie nennt (`PF-erkennung`, `E-1645`; gelesen über `useBezeichnungen()`).
 * `HERKUNFT` oben ist dieselbe Tafel mit der Bezeichnung der eigenen
 * Installation, bis die geladene da ist.
 */
export function herkunftMit(
  bezeichnungen: Pick<Bezeichnungen, 'webkundeHerkunftBezeichnung'>,
): Readonly<Record<Customer['origin'], string>> {
  return { ...HERKUNFT, famesystems: bezeichnungen.webkundeHerkunftBezeichnung };
}

/** Geschäfts- oder Privatkunde. */
export const KUNDENTYP: Readonly<Record<Customer['customerType'], string>> = {
  b2b: 'Geschäftskunde',
  b2c: 'Privatkunde',
};

/** Angegeben oder abgeleitet — der Unterschied zwischen Angabe und Vermutung. */
export const TYPQUELLE: Readonly<Record<Customer['customerTypeSource'], string>> = {
  declared: 'angegeben',
  derived: 'abgeleitet',
};

/** Aktiv oder stillgelegt. Gelöscht wird nicht. */
export const STAMMSTATUS: Readonly<Record<Customer['status'], string>> = {
  active: 'Aktiv',
  inactive: 'Stillgelegt',
};

/** Der Stand einer Verknüpfung. */
export const LINKSTATUS: Readonly<Record<Link['status'], string>> = {
  candidate: 'Offen',
  duplicate: 'Dublette',
  distinct: 'Verschieden',
};

/**
 * Wer die Verknüpfung erklärt hat.
 *
 * Für einen Prüfer sind das zwei verschiedene Nachweise, und deshalb steht die
 * Herkunft auf jeder Karte und ist unveränderlich.
 */
export const ERKANNT_VON: Readonly<Record<Link['detectedBy'], string>> = {
  system: 'vom System gemeldet',
  user: 'von Hand erklärt',
};

/** Das Ergebnis einer USt-IdNr.-Abfrage. */
export const VAT_ERGEBNIS: Readonly<Record<VatCheck['result'], string>> = {
  valid: 'gültig',
  invalid: 'ungültig',
  unavailable: 'nicht erreichbar',
};

/** Auf welchem Weg geprüft wurde. */
export const VAT_METHODE: Readonly<Record<VatCheck['method'], string>> = {
  bzst_manual: 'BZSt, von Hand',
  bzst_api: 'BZSt, Schnittstelle',
  mias_api: 'MIAS, Schnittstelle',
};

// --- Phase 3: Belegwesen ---------------------------------------------------

// `documentTypeSchema`, `documentStatusSchema`, `priceBasisSchema` und
// `taxScenarioSchema` kommen aus `@fameacc/contracts` (Import am Kopf dieser
// Datei) und werden von dort re-exportiert — nicht hier neu aufgezählt.

export const billingAddressSchema = ohneMarken(billingAddressViewVertragSchema);

/** Die Anschrift, wie der Beleg sie trägt. */
export type BillingAddress = z.infer<typeof billingAddressSchema>;

export const legacyDunningSchema = ohneMarken(legacyDunningViewVertragSchema);

export type LegacyDunning = z.infer<typeof legacyDunningSchema>;

export const documentSummarySchema = ohneMarken(documentSummaryVertragSchema);

/** Ein Beleg, wie die Liste ihn zeigt. */
export type DocumentSummary = z.infer<typeof documentSummarySchema>;

export const documentLineSchema = ohneMarken(documentLineViewVertragSchema);

/** Eine Belegposition. */
export type DocumentLine = z.infer<typeof documentLineSchema>;

export const documentTaxGroupSchema = ohneMarken(documentTaxGroupViewVertragSchema);

/** Eine Steuersatzgruppe. */
export type DocumentTaxGroup = z.infer<typeof documentTaxGroupSchema>;

export const documentViewSchema = ohneMarken(documentViewVertragSchema);

/** Ein Beleg samt Positionen. */
export type DocumentView = z.infer<typeof documentViewSchema>;

/**
 * Die zwei Portalformen, die die Belegseite anzeigt — unverändert aus dem
 * Vertrag durchgereicht, damit `DocumentPage.tsx` sie benennen kann, ohne den
 * Vertrag ein zweites Mal zu importieren.
 */
export type {
  DokumentAngebotEntscheidung,
  DokumentAngebotEntscheidungMail,
  DokumentPortalEreignis,
} from '@fameacc/contracts';

export const documentVersandEntrySchema = ohneMarken(documentVersandEntryVertragSchema);

/** Ein Versuch, einen Beleg per E-Mail zu verschicken. */
export type DocumentVersandEntry = z.infer<typeof documentVersandEntrySchema>;

export const documentVersandHistorySchema = ohneMarken(documentVersandListResponseVertragSchema);

export const documentVersandEntwurfSchema = ohneMarken(documentVersandEntwurfVertragSchema);

/** Was der Versanddialog vorbelegt. */
export type DocumentVersandEntwurf = z.infer<typeof documentVersandEntwurfSchema>;

/**
 * Die Belegliste samt der echten Gesamtzahl zu denselben Filtern.
 *
 * `total` ist **nicht** die Seitengrösse — sie ist ein echtes `COUNT(*)` über
 * dieselben Bedingungen wie `documents` (Auftrag `W-belegtabs`). Vorher gab es
 * hier bewusst keine Zahl: Die Seitengrösse als Bestand auszugeben, wäre die
 * geschätzte Zahl gewesen, die Spec 6.5 für Abzeichen verbietet.
 */
export const documentListSchema = ohneMarken(documentListResponseVertragSchema);

export const issueResultSchema = ohneMarken(issueResultVertragSchema);

/** Das Ergebnis der Ausstellung. */
export type IssueResult = z.infer<typeof issueResultSchema>;

export const priceBasisWarningSchema = ohneMarken(priceBasisWarningVertragSchema);

/** Eine Warnung des Basiswechsels. */
export type PriceBasisWarning = z.infer<typeof priceBasisWarningSchema>;

export const priceBasisChangeSchema = ohneMarken(priceBasisChangeResultVertragSchema);

/** Das Ergebnis des Basiswechsels. */
export type PriceBasisChangeResult = z.infer<typeof priceBasisChangeSchema>;

export const documentWithoutPdfSchema = ohneMarken(documentWithoutPdfViewVertragSchema);

/** Ein Beleg ohne Archivstück. */
export type DocumentWithoutPdf = z.infer<typeof documentWithoutPdfSchema>;

/** Die Sicht auf die Belege ohne Archivstück. */
export const documentWithoutPdfListSchema = ohneMarken(documentWithoutPdfListResponseVertragSchema);

export const numberRangeReportSchema = ohneMarken(numberRangeReportRowVertragSchema);

/** Eine Zeile des Lückenberichts. */
export type NumberRangeReport = z.infer<typeof numberRangeReportSchema>;

/** Der Lückenbericht über alle Kreise. */
export const numberRangeReportListSchema = ohneMarken(numberRangeReportListResponseVertragSchema);

export const numberGapSchema = ohneMarken(numberGapViewVertragSchema);

/** Eine begründete Lücke. */
export type NumberGap = z.infer<typeof numberGapSchema>;

export const numberGapDetailSchema = ohneMarken(numberGapDetailVertragSchema);

/** Die Aufzählung der fehlenden Zählerstände. */
export type NumberGapDetail = z.infer<typeof numberGapDetailSchema>;

export const issuerBankAccountSchema = ohneMarken(issuerBankAccountViewVertragSchema);

/** Eine Bankverbindung. */
export type IssuerBankAccount = z.infer<typeof issuerBankAccountSchema>;

export const issuerProfileSchema = ohneMarken(issuerProfileViewVertragSchema);

/** Eine Rechnungsstellerfassung. */
export type IssuerProfile = z.infer<typeof issuerProfileSchema>;

/** Die Fassungen des Rechnungsstellers, neueste zuerst. */
export const issuerProfileListSchema = ohneMarken(issuerProfileListResponseVertragSchema);

/**
 * Die deutschen Bezeichnungen der vierzehn Belegarten.
 *
 * **Die drei letzten sind Archivbelege des Altsystems** (Migration `0119`,
 * `AI-typwege`). Sie tragen den Zusatz „(Altbestand)" im Wortlaut und nicht nur
 * eine Farbe: Die Belegliste zeigt tausende von ihnen zwischen den eigenen
 * Belegen, und wer eine Rechnung von 2022 anklickt, muss vorher wissen, dass
 * sie nicht aus diesem System stammt — Rendern, Versand und Storno sind an ihr
 * nicht möglich (`DOCUMENT_ARCHIVE_READONLY`).
 *
 * `Record<DocumentSummary['type'], string>` ist dabei der Wächter: Eine neue
 * Belegart im Vertrag ist hier ein Typfehler und keine leere Zelle.
 *
 * **`credit_note` heisst „Rechnungskorrektur" und nirgends „Gutschrift".** § 14
 * Abs. 2 Satz 2 UStG bezeichnet mit „Gutschrift" die Abrechnung durch den
 * LEISTUNGSEMPFÄNGER; das Wort auf einer Rechnungskorrektur behauptet eine
 * Abrechnungsrichtung, die es nicht gibt — ein häufiger und in der
 * Betriebsprüfung teurer Fehler. Deshalb heisst auch das Kreiskennzeichen `RK`
 * und nicht `GS`.
 */
export const BELEGART: Readonly<Record<DocumentSummary['type'], string>> = {
  quote: 'Angebot',
  order_confirmation: 'Auftragsbestätigung',
  invoice: 'Rechnung',
  partial_invoice: 'Teilrechnung',
  final_invoice: 'Schlussrechnung',
  recurring_invoice: 'Aborechnung',
  credit_note: 'Rechnungskorrektur',
  cancellation: 'Stornorechnung',
  proforma: 'Proformarechnung',
  delivery_note: 'Lieferschein',
  dunning: 'Mahnung',
  legacy_invoice: 'Rechnung (Altbestand)',
  legacy_cancellation: 'Storno (Altbestand)',
  legacy_credit_note: 'Gutschrift (Altbestand)',
};

/**
 * Die drei Archivbelegarten — für die Kennzeichnung in Liste und Einzelansicht.
 *
 * Aus dem Vertrag abgeleitet und nicht abgeschrieben: `istArchivbelegart()` ist
 * dieselbe Funktion, die die API benutzt, und sie ist dort ihrerseits gegen
 * `ist_archivbelegtyp()` aus Migration `0119` gestellt.
 */
export { istArchivbelegart };

/**
 * Die sechs vereinten Belegzustände — die Beschriftung der einen Spalte
 * «Zustand» (Auftrag `AI-zustandvereint`, 2026-09-05).
 *
 * **Ersetzt die drei Lebenszyklus-Beschriftungen an dieser Stelle.** Bis Zug
 * 141 zeigte die Spalte den Lebenszyklus (`draft`/`issued`/`cancelled`) und
 * daneben stand eine zweite Spalte «Altstatus» für den übernommenen
 * Zahlungsstand — je nach Belegherkunft war immer genau eine von beiden leer.
 * Der Auftraggeber hat am 2026-09-05 eine Spalte für beides verlangt.
 *
 * **Der Lebenszyklus ist damit nicht verschwunden.** Er steht in der
 * Belegansicht weiterhin vollständig im Verlauf (`StatusTrail.tsx`:
 * Angelegt · Freigegeben · Ausgestellt · Versand vermerkt · Storniert) —
 * dort, wo er hingehört: als Kette mit Zeitpunkt und Handelndem, nicht als
 * ein Wort in einer Tabellenzelle.
 *
 * `Record<Belegzustand, string>` ist derselbe Wächter wie bei
 * `BELEGART`/`ALTZAHLSTATUS`: ein sechster Wert im Vertrag ist hier ein
 * Typfehler und keine leere Zelle.
 */
export const BELEGZUSTAND: Readonly<Record<DocumentSummary['belegzustand'], string>> = {
  entwurf: 'Entwurf',
  offen: 'Offen',
  bezahlt: 'Bezahlt',
  storniert: 'Storniert',
  fehler: 'Fehler',
  // Seit `AI-gutschriftstatus` (2026-09-05): eine ausgeführte Alt-Gutschrift
  // (`fa_gutschrift.status = 1`) ist weder Forderung noch Aufhebung —
  // ein eigener, neutraler Endzustand.
  erledigt: 'Erledigt',
};

/**
 * Die sechs Ausprägungen des übernommenen Altsystem-Zahlungsstands
 * (`document.legacyStatus`, Migration `0119`, `D-2`) — Auftrag
 * `AI-zahlstatusanzeige`.
 *
 * **Fünf davon sind benannte Codes (seit `AI-gutschriftstatus`, 2026-09-05,
 * inklusive `erledigt`, Code `2`), die sechste (`unbenannt`) ist eine reine
 * Leseseiten-Auskunft und nie ein Wert, den die Schreibseite noch erzeugt**
 * (Nachtrag Zug 141, 2026-09-04): `POST /api/v1/invoices/import` lässt seit
 * `AI-gutschriftstatus` nur `-1`/`1`/`2`/`4`/`5` durch; `unbenannt` erscheint
 * ausschliesslich an einer Zeile, deren gespeicherter Code älter ist als
 * diese Sperre oder auf einem Weg entstand, der an ihr vorbeigeschrieben
 * hat — die Anzeige zeigt es neutral statt die Belegliste mit einem
 * Serverfehler zu Fall zu bringen.
 *
 * Nur an Archivbelegen gesetzt (`legacyStatus !== null`); `Record<
 * NonNullable<DocumentSummary['legacyStatus']>, string>` ist derselbe
 * Wächter wie bei `BELEGART`/`BELEGZUSTAND` — ein neuer Wert im Vertrag ist
 * hier ein Typfehler und keine leere Zelle.
 */
export const ALTZAHLSTATUS: Readonly<Record<NonNullable<DocumentSummary['legacyStatus']>, string>> = {
  bezahlt: 'Bezahlt',
  unbezahlt: 'Unbezahlt',
  storniert: 'Storniert',
  fehler: 'Fehler',
  // Seit `AI-gutschriftstatus` (2026-09-05): Code 2, benannt für die
  // ausgeführte Alt-Gutschrift (siehe `legacyDocumentStatusSchema`).
  erledigt: 'Erledigt',
  // Seit `AI-zustandvereint` (2026-09-05) erscheinen diese Beschriftungen nur
  // noch in der HERKUNFTSzeile der Belegansicht („Altsystem: …"); das Wort
  // „Altstatus" davor waere dort eine Dopplung und ist deshalb weg.
  unbenannt: 'unbenannter Code',
};

/**
 * Die beiden Preisbasen, in der Sprache des Anwenders.
 *
 * Ausgeschrieben und nicht bloss „netto"/„brutto": Der Unterschied ist, WELCHE
 * Zahl vereinbart war, und das ist die Frage, die die Beschriftung stellen muss.
 */
export const PREISBASIS: Readonly<Record<DocumentSummary['priceBasis'], string>> = {
  net: 'Nettopreise — der Endpreis ergibt sich',
  gross: 'Bruttopreise — der Endpreis ist vereinbart',
};

/** Die Spaltenüberschrift des Einzelpreises. Nie bloss „Preis" (Spec 9). */
export const EINZELPREIS_KOPF: Readonly<Record<DocumentSummary['priceBasis'], string>> = {
  net: 'Einzelpreis netto',
  gross: 'Einzelpreis brutto',
};

/** Die sechs Steuerszenarien in der Sprache des Belegs. */
export const STEUERSZENARIO: Readonly<Record<DocumentSummary['taxScenario'], string>> = {
  domestic: 'Inland',
  eu_b2b_reverse_charge: 'EU, Geschäftskunde — Reverse Charge',
  eu_b2c_oss: 'EU, Privatkunde — OSS',
  eu_b2c_domestic_vat: 'EU, Privatkunde — deutsche Umsatzsteuer',
  third_country_b2c: 'Drittland, Privatkunde',
  third_country_b2b: 'Drittland, Geschäftskunde',
  kleinunternehmer: 'Kleinunternehmer (§ 19 UStG) — keine Umsatzsteuer',
};

/** Angegeben oder abgeleitet. In Phase 3 ausnahmslos `declared` (Spec 8.2). */
export const SZENARIOQUELLE: Readonly<Record<DocumentSummary['taxScenarioSource'], string>> = {
  declared: 'angegeben',
  derived: 'abgeleitet',
};

// --- Bankanbindung Stufe 1 ------------------------------------------------

/** Die deutschen Bezeichnungen des Abgleichstatus (`match_status`, Spec 5.1). */
export const ABGLEICH: Readonly<Record<string, string>> = {
  unmatched: 'Offen',
  suggested: 'Vorschlag',
  matched: 'Zugeordnet',
  ignored: 'Übergangen',
};

/**
 * Die deutschen Bezeichnungen des Kontierungsstands (`kontierungStatus`,
 * `V-kontkomfort`) — unabhängig von `ABGLEICH` (siehe Feldkommentar in
 * `bankTransactionSchema`).
 */
export const KONTIERUNGSSTATUS: Readonly<Record<string, string>> = {
  offen: 'Offen',
  in_arbeit: 'In Arbeit',
  freigegeben: 'Freigegeben',
  gebucht: 'Gebucht',
};

/**
 * Nimmt diese Bewegung noch eine Kontierung an?
 *
 * **`freigegeben` und `gebucht` tun es nicht, aus zwei verschiedenen
 * Gründen** — und deshalb steht die Frage hier einmal statt zweimal in zwei
 * Umsatzlisten: Eine freigegebene Kontierung wartet auf nichts mehr, und eine
 * GEBUCHTE Bewegung weist eine weitere Kontierungszeile serverseitig ab
 * (`KONTIERUNG_ALREADY_BOOKED`, `W-kontkorrektur`); ihr Weg ist der Storno.
 * Eine Schaltfläche, die in eine Maske führt, die abweisen muss, ist keine
 * Hilfe.
 */
export function istKontierbar(status: string): boolean {
  return status === 'offen' || status === 'in_arbeit';
}

/**
 * Die Herkunft eines Auszugs.
 *
 * `Upload` und `FinTS` in genau dieser Schreibweise, wie Spec 10 sie verlangt.
 * Sie sind für einen Prüfer zwei verschiedene Nachweise: per Hand geladen oder
 * abgerufen (Spec 1.4).
 */
export const AUSZUGSHERKUNFT: Readonly<Record<string, string>> = {
  upload: 'Upload',
  fints: 'FinTS',
  // **Die zwei Zahldienste stehen hier seit dem 2026-08-21.** `statementSourceSchema`
  // im Vertrag fuehrt sie seit der Zahldienste-Aera, und `bank_statement_import`
  // traegt sie fuer jedes Abruffenster. Ohne diese zwei Zeilen zeigt die
  // Auszugsliste eines Zahldienstkontos den rohen Wert `paypal` an -- und das
  // Herkunftsschema darunter wies die Zeile sogar ganz ab.
  paypal: 'PayPal',
  mollie: 'Mollie',
};

export const bankAccountSchema = ohneMarken(bankAccountVertragSchema);

/** Ein Bankkonto. */
export type BankAccount = z.infer<typeof bankAccountSchema>;

/** Die Kontenliste. */
export const bankAccountListSchema = ohneMarken(bankAccountListResponseVertragSchema);

export const bankTransactionSchema = ohneMarken(bankTransactionVertragSchema);

/** Ein Bankumsatz. */
export type BankTransaction = z.infer<typeof bankTransactionSchema>;

export const bankTransactionListSchema = ohneMarken(bankTransactionListVertragSchema);

export const bankStatementSchema = ohneMarken(bankStatementVertragSchema);

/** Ein eingelesener Auszug. */
export type BankStatement = z.infer<typeof bankStatementSchema>;

/** Die Auszugsliste. */
export const bankStatementListSchema = ohneMarken(bankStatementListResponseVertragSchema);

export const statementImportResultSchema = ohneMarken(statementImportResultVertragSchema);

/** Das Ergebnis einer Datei. */
export type StatementImportResult = z.infer<typeof statementImportResultSchema>;

/**
 * Ein Anschlussbruch (Spec 4.4.2).
 *
 * **Ein Befund und kein Fehler.** Die Kette kann legitim lückenhaft aufgebaut
 * werden, wenn jemand Auszüge in beliebiger Reihenfolge nachträgt; der Import
 * wird deshalb nicht abgewiesen.
 */
export const continuityBreakSchema = ohneMarken(continuityBreakVertragSchema);

/** Ein Anschlussbruch. */
export type ContinuityBreak = z.infer<typeof continuityBreakSchema>;

export const statementImportBatchResultSchema = ohneMarken(statementImportBatchResultVertragSchema);

/** Der Bericht über einen Hochladevorgang. */
export type StatementImportBatchResult = z.infer<typeof statementImportBatchResultSchema>;

// --- Zahldienste Stufe A ---------------------------------------------------

/**
 * Die Namen der zwei Dienste, so wie ihre Anbieter sie schreiben.
 *
 * `PayPal` und `Mollie` in genau dieser Schreibweise — sie stehen auf den
 * Abrechnungen, die ein Steuerberater danebenlegt.
 */
export const ZAHLDIENST: Readonly<Record<string, string>> = {
  fints: 'Bank (FinTS)',
  paypal: 'PayPal',
  mollie: 'Mollie',
};

/**
 * Die deutschen Bezeichnungen des Abrufzustands (`fetch_status`, Migration `0038`).
 *
 * **Drei Werte und nicht zwei.** `verworfen` heisst gelesen und wieder
 * weggeworfen — die Klammer brach; `gescheitert` heisst, es kam nichts Lesbares.
 * Wer die zwei zusammenzöge, verlöre die Auskunft, ob der Anbieter geantwortet
 * hat.
 */
export const ABRUFZUSTAND: Readonly<Record<string, string>> = {
  uebernommen: 'Übernommen',
  verworfen: 'Verworfen',
  gescheitert: 'Gescheitert',
};

/**
 * Die deutschen Bezeichnungen der Klammerlage (`E-227`, `E-215`).
 *
 * **Drei Werte, und der dritte ist der Grund für die Tabelle.** «Noch nicht
 * klammerbar» ist weder Bruch noch Aufgehen, sondern die Auskunft, dass der Tag
 * Vorlauf aus `E-215` noch nicht um ist. Wer ihn mit `gebrochen` zusammenzöge,
 * meldete jeden frischen Abruf als Befund.
 */
export const KLAMMERLAGE: Readonly<Record<string, string>> = {
  stimmig: 'Klammer geht auf',
  gebrochen: 'Klammer gebrochen',
  noch_nicht_klammerbar: 'Noch nicht klammerbar',
};

export const fetchContinuityBreakSchema = ohneMarken(fetchContinuityBreakVertragSchema);

/** Ein Bruch zwischen zwei Abruffenstern. */
export type FetchContinuityBreak = z.infer<typeof fetchContinuityBreakSchema>;

export const fetchReportSchema = ohneMarken(fetchReportVertragSchema);

/** Der Bericht eines Abrufs. */
export type FetchReport = z.infer<typeof fetchReportSchema>;

/** Die Abruffenster eines Kontos, jüngstes zuerst. */
export const uebersprungenesFensterSchema = ohneMarken(uebersprungenesFensterVertragSchema);

export const fetchListSchema = ohneMarken(fetchListVertragSchema);

export const fetchWindowListSchema = ohneMarken(fetchWindowListVertragSchema);

/** Ein uebersprungener Abschnitt eines Historienlaufs. */
export type UebersprungenesFenster = z.infer<typeof uebersprungenesFensterSchema>;

/**
 * Eine Gruppe der Klärliste, wie der Deckungsbericht sie je Fenster liefert.
 *
 * **Sie kommt vom Server und wird nicht im Browser gebildet.** Die Verkürzung
 * ersetzt jede Ziffernfolge durch ein Zeichen; sie im Browser nachzubauen wäre
 * eine zweite Auslegung derselben Regel — und die erste hat `erkennung.ts`
 * bereits über denselben Text laufen lassen.
 */
export const nichttreffergruppeSchema = ohneMarken(nichttreffergruppeVertragSchema);

/** Eine Gruppe der Klärliste. */
export type Nichttreffergruppe = z.infer<typeof nichttreffergruppeSchema>;

/** Ein Abruffenster im Deckungsbericht (`E-227`). */
export const paymentWindowSchema = ohneMarken(paymentWindowVertragSchema);

/** Ein Abruffenster im Deckungsbericht. */
export type PaymentWindow = z.infer<typeof paymentWindowSchema>;

/**
 * Der Zahldienstteil des Deckungsberichts — **optional und nicht mit Nullen
 * gefüllt**.
 *
 * Ein Bankkonto bekäme sonst einen Abschnitt mit lauter Nullen, und ein Leser
 * müsste raten, ob das «keine Abrufe» oder «kein Zahldienst» heisst.
 */
export const paymentServiceCoverageSchema = ohneMarken(paymentServiceCoverageVertragSchema);

/** Der Zahldienstteil des Deckungsberichts. */
export type PaymentServiceCoverage = z.infer<typeof paymentServiceCoverageSchema>;

/**
 * Eine Lücke im Bestand (Spec 9.1).
 *
 * **Die Definition ist nicht selbstverständlich.** `from_date` ist das
 * `OPBD`-Datum, aufeinanderfolgende Auszüge überlappen sich deshalb um einen Tag.
 * Eine Lücke liegt vor, wenn `to_date(A) <> from_date(B)` — nicht, wenn ein
 * Kalendertag dazwischenliegt. Gerechnet wird das auf dem Server; hier wird es
 * angezeigt.
 */
export const coverageGapSchema = ohneMarken(coverageGapVertragSchema);

/** Eine Lücke im Bestand. */
export type CoverageGap = z.infer<typeof coverageGapSchema>;

export const coverageReportSchema = ohneMarken(coverageReportVertragSchema);

/** Der Lückenbericht. */
export type CoverageReport = z.infer<typeof coverageReportSchema>;

/**
 * Die Lage eines geprüften Endpunkts (Spec Zahldienste 13.2).
 *
 * **Vier Werte, und der Unterschied zwischen `gesperrt` und `kein_zugang` ist
 * der ganze Anlass der Probe.** Ein Zugang, der zu vier Fünfteln funktioniert,
 * ist gefährlicher als einer, der gar nicht geht: Der erste kommt durch die
 * Anmeldung und verweigert die Saldoklammer, der zweite bricht sichtbar.
 */
export const ZUGANGSLAGE: Readonly<Record<string, string>> = {
  erreichbar: 'erreichbar',
  gesperrt: 'gesperrt — angemeldet, aber ohne Recht',
  kein_zugang: 'kein Zugang — die Anmeldung wird abgelehnt',
  unerreichbar: 'keine Antwort',
};

export const zugangspunktSchema = ohneMarken(zugangspunktVertragSchema);

/** Ein geprüfter Endpunkt. */
export type Zugangspunkt = z.infer<typeof zugangspunktSchema>;

export const zugangsprobeSchema = ohneMarken(zugangsprobeVertragSchema);

/** Das Ergebnis der Rechteprobe. */
export type Zugangsprobe = z.infer<typeof zugangsprobeSchema>;

// --- FinTS Stufe 2a ---------------------------------------------------------

/**
 * Der Zustand des FinTS-Zugangs (`GET /bank-accounts/:id/fints`, Spec 10).
 *
 * **Spiegelt `fintsZugangSchema` aus `@fameacc/contracts`, Feld für Feld** —
 * derselbe Aufbau wie jedes andere Antwortschema dieser Datei (`bankAccountSchema`,
 * `fetchReportSchema`): Die Aussenform lebt hier, damit sie unabhängig von der
 * internen Form des Dienstes bleibt. Für die **Eingabe** (`PUT`) gilt das
 * NICHT — dort wird `fintsZugangEingabeSchema` direkt aus dem Vertrag
 * importiert und validiert, dieselbe Bauform wie `BankAccountDialog.tsx` mit
 * `bankAccountCreateSchema`. **Kein Feld für die PIN, in keiner Gestalt**
 * (`E-313`, `E-319`) — das Schema kennt keins, und was es nicht kennt, kann
 * `request()` nicht durchlassen.
 */
export const fintsZugangTanVerfahrenSchema = ohneMarken(fintsZugangTanVerfahrenVertragSchema);

/** Ein TAN-Verfahren aus der zwischengespeicherten BPD des Zugangs. */
export type FintsZugangTanVerfahren = z.infer<typeof fintsZugangTanVerfahrenSchema>;

export const fintsZugangSchema = z.discriminatedUnion('eingerichtet', [
  z.object({ eingerichtet: z.literal(false) }),
  z.object({
    eingerichtet: z.literal(true),
    url: z.string(),
    blz: z.string(),
    benutzerkennung: z.string(),
    kundenkennung: z.string().nullable(),
    tanVerfahrenId: z.number().int().nullable(),
    tanMedium: z.string().nullable(),
    maxTage: z.number().int().nullable(),
    /** Ob eine PIN hinterlegt ist — **nicht**, welche. */
    pinHinterlegt: z.boolean(),
    pinHinterlegtAm: z.string().nullable(),
    letzteStarkeAuth: z.string().nullable(),
    letzterAbruf: z.string().nullable(),
    /** Die Vorschau aus Spec 8.3 — `letzte_starke_auth` plus neunzig Tage, niemals eine Sperre. */
    auffrischungVoraussichtlichAm: z.string().nullable(),
    /** Tage bis dahin; negativ, wenn der Zeitpunkt vorbei ist. */
    tageBisAuffrischung: z.number().int().nullable(),
    /**
     * Wann der **tägliche Hintergrundabruf** zuletzt begonnen hat
     * (`F-fintstakt`). `null` heisst «noch nie» — er fasst nur Zugänge mit
     * hinterlegter PIN an.
     */
    taktLetzterVersuch: z.string().nullable(),
    /**
     * Wie er ausgegangen ist. `freigabe_faellig` ist **kein Fehler**, sondern
     * die Aufforderung, die Freigabe einmal von Hand zu erneuern.
     */
    taktBefund: fintsTaktBefundSchema.nullable(),
    /** Die kurze, geschwärzte Meldung zum Befund. `null` bei `ok`. */
    taktMeldung: z.string().nullable(),
    /**
     * Die dem Institut bekannten TAN-Verfahren, aus der zwischengespeicherten
     * BPD des letzten erfolgreichen Dialogs (`F-tanliste`). `null` heisst
     * „noch kein erfolgreicher Dialog", nicht „das Institut bietet nichts an".
     */
    bekannteTanVerfahren: z.array(fintsZugangTanVerfahrenSchema).nullable(),
  }),
]);

/** Der Zustand des FinTS-Zugangs. */
export type FintsZugang = z.infer<typeof fintsZugangSchema>;

/** Die deutschen Bezeichnungen des Laufzustands (`fintsLaufZustandSchema`). */
export const FINTS_LAUF_ZUSTAND: Readonly<Record<string, string>> = {
  laeuft: 'Läuft',
  wartet_auf_freigabe: 'Wartet auf Freigabe',
  fertig: 'Fertig',
  abgebrochen: 'Abgebrochen',
};

export const fintsSaldoAbgleichSchema = ohneMarken(fintsSaldoAbgleichVertragSchema);

/** Der Saldoabgleich eines Abrufs. */
export type FintsSaldoAbgleich = z.infer<typeof fintsSaldoAbgleichSchema>;

export const fintsAbrufBerichtSchema = ohneMarken(fintsAbrufBerichtVertragSchema);

/** Der Bericht eines Abrufs. */
export type FintsAbrufBericht = z.infer<typeof fintsAbrufBerichtSchema>;

export const fintsBankRueckmeldungSchema = ohneMarken(fintsBankRueckmeldungVertragSchema);

/** Eine Rückmeldung des Instituts, mit Text und, wenn bekannt, Bezugssegment. */
export type FintsBankRueckmeldung = z.infer<typeof fintsBankRueckmeldungSchema>;

export const fintsDrahtNachrichtSchema = ohneMarken(fintsDrahtNachrichtVertragSchema);

/** Eine gewechselte FinTS-Nachricht, geschwärzt. */
export type FintsDrahtNachricht = z.infer<typeof fintsDrahtNachrichtSchema>;

export const fintsLaufSchema = ohneMarken(fintsLaufVertragSchema);

/** Der Zustand eines Abruflaufs. */
export type FintsLauf = z.infer<typeof fintsLaufSchema>;

export const bankRueckmeldungEintragSchema = ohneMarken(bankRueckmeldungEintragVertragSchema);

export const lastschriftEinreichungLaufSchema = ohneMarken(lastschriftEinreichungLaufVertragSchema);

/** Der Zustand eines Lastschrift-Einreichungslaufs. */
export type LastschriftEinreichungLauf = z.infer<typeof lastschriftEinreichungLaufSchema>;

export const fintsZugangstestVerfahrenSchema = ohneMarken(fintsZugangstestVerfahrenVertragSchema);

/** Ein TAN-Verfahren des Zugangstests. */
export type FintsZugangstestVerfahren = z.infer<typeof fintsZugangstestVerfahrenSchema>;

export const fintsZugangstestSchema = ohneMarken(fintsZugangstestVertragSchema);

/** Der Zustand eines Zugangstests. */
export type FintsZugangstest = z.infer<typeof fintsZugangstestSchema>;

export const fintsEinrichtungSchema = ohneMarken(fintsEinrichtungVertragSchema);

/** Der Zustand einer geführten Einrichtung. */
export type FintsEinrichtung = z.infer<typeof fintsEinrichtungSchema>;

export const fintsTanMedienAbrufSchema = ohneMarken(fintsTanMedienAbrufVertragSchema);

/** Der Ausgang eines Medienabrufs. */
export type FintsTanMedienAbruf = z.infer<typeof fintsTanMedienAbrufSchema>;

export const fintsInstitutSchema = ohneMarken(fintsInstitutVertragSchema);

/** Ein Institut aus der Suche. */
export type FintsInstitut = z.infer<typeof fintsInstitutSchema>;

export const fintsInstitutListeSchema = ohneMarken(fintsInstitutListeVertragSchema);

// --- Eingangsrechnungen Stufe A -------------------------------------------

/**
 * Die Antwortformen der Eingangsbelege.
 *
 * **Beträge bleiben Zeichenketten**, wie überall in dieser Datei: `betragSchema`
 * ist `z.string()`, und es wird nichts in eine Zahl umgewandelt.
 *
 * **Warum sie hier stehen und nicht aus `@fameacc/contracts` kommen.** Dieselbe
 * Trennung wie bei Bank und Zahldiensten: Dort steht der Vertrag, den die API
 * gegen sich selbst prüft; hier steht, was das Frontend zu lesen bereit ist.
 * Die Formen sind absichtlich **nicht `.strict()`** — ein Feld, das die API
 * hinzufügt, soll eine ältere Oberfläche nicht lahmlegen. Das gilt für die
 * OBJEKTFORM, nicht für die Wertelisten ihrer `z.enum(...)`-Felder: Die kommen
 * unverändert aus dem Vertrag (`incomingExtractionSourceSchema` und andere,
 * Import am Kopf dieser Datei) und werden hier nicht zusätzlich aufgezählt.
 */

/** Die drei Formklassen — dieselbe Einteilung wie im Messbericht. */
export const FORMKLASSE_SATZ: Readonly<Record<string, string>> = {
  xml: 'eingebettetes XML vorhanden',
  textlage: 'Textlage vorhanden',
  scan: 'Scan ohne Textlage',
};

export const probeSchema = ohneMarken(probeResultVertragSchema);

export const incomingDocumentSchema = ohneMarken(incomingDocumentVertragSchema);

export type IncomingDocument = z.infer<typeof incomingDocumentSchema>;

export const incomingKorbvorschlagSchema = ohneMarken(incomingKorbvorschlagVertragSchema);

export type IncomingKorbvorschlag = z.infer<typeof incomingKorbvorschlagSchema>;

/**
 * Die vier Verwerfensgründe — geschlossene Liste, vom Auftraggeber gesetzt.
 * Der Wertesatz kommt aus `@fameacc/contracts` und wird hier nicht
 * abgeschrieben (`no-restricted-syntax`, und aus gutem Grund: eine zweite Liste
 * driftet beim ersten fünften Wert).
 */
export type IncomingDocumentDiscardReason = z.infer<typeof incomingDocumentDiscardReasonSchema>;

export const incomingDocumentDiscardSchema = ohneMarken(incomingDocumentDiscardVertragSchema);

export const incomingKorbzeileSchema = ohneMarken(incomingKorbzeileVertragSchema);

export type IncomingKorbzeile = z.infer<typeof incomingKorbzeileSchema>;

export const incomingDocumentListSchema = ohneMarken(incomingKorbListeVertragSchema);

export const incomingUploadResultSchema = ohneMarken(incomingUploadResultVertragSchema);

export type IncomingUploadResult = z.infer<typeof incomingUploadResultSchema>;

export const incomingInvoiceSchema = ohneMarken(incomingInvoiceVertragSchema);

export type IncomingInvoice = z.infer<typeof incomingInvoiceSchema>;

export const incomingInvoiceListSchema = ohneMarken(incomingInvoiceListVertragSchema);

/** Die Liste samt **drei** Zahlen — die gefilterte, der Bestand und mit Hinweis. */
export type IncomingInvoiceList = z.infer<typeof incomingInvoiceListSchema>;

export const incomingCaptureResultSchema = ohneMarken(incomingCaptureResultVertragSchema);

export type IncomingCaptureResult = z.infer<typeof incomingCaptureResultSchema>;

export const incomingTaxLineSchema = ohneMarken(incomingTaxLineVertragSchema);

export type IncomingTaxLine = z.infer<typeof incomingTaxLineSchema>;

export const incomingInvoiceDetailSchema = ohneMarken(incomingInvoiceDetailVertragSchema);

export type IncomingInvoiceDetail = z.infer<typeof incomingInvoiceDetailSchema>;

export const belegAusleseSchema = ohneMarken(belegExtractionVertragSchema);

export type BelegAuslese = z.infer<typeof belegAusleseSchema>;

/**
 * Die Vorbelegung je Kreditor.
 *
 * **`felder` und `geoeffnetAm` sind keine Zierde.** Ohne `felder` ist «zwei von
 * zwei stehengeblieben» von «vier von vier» nicht zu unterscheiden; ohne
 * `geoeffnetAm` gibt es keinen Anfangspunkt für `capture_seconds`, den die
 * **Serveruhr** gesetzt hat. Die Maske reicht ihn unverändert zurück.
 *
 * **`auslese` kam am 2026-08-22 dazu.** `currency`, `taxRate` und `amounts`
 * oben sind bereits der mit ihr **verschmolzene** Wert — Auslese vor
 * Kreditor-Erfahrungswert, serverseitig entschieden. `auslese` selbst bleibt
 * daneben stehen, weil vier ihrer Felder (Rechnungsnummer, die drei
 * Datumsangaben) kein Kreditor-Gegenstück haben und die Maske ihre Quelle
 * zeigen soll.
 *
 * **`dueDate` kam am selben Tag dazu.** `dueDays` bleibt die rohe
 * Kreditor-Angabe in Tagen; `dueDate` ist der daraus gerechnete Vorschlag —
 * Auslese, sonst Rechnungsdatum plus `dueDays`, sonst `null` — und der Wert,
 * den das Feld „Fälligkeit" tatsächlich anzeigt.
 */
export const prefillSchema = ohneMarken(incomingPrefillVertragSchema);

export type IncomingPrefill = z.infer<typeof prefillSchema>;
export type IncomingVendorSuggestion = NonNullable<IncomingPrefill['vendorSuggestion']>;

export const incomingDuplicateSchema = ohneMarken(duplicateCandidateVertragSchema);

export type IncomingDuplicate = z.infer<typeof incomingDuplicateSchema>;

export const incomingDuplicateListSchema = ohneMarken(duplicateCandidateListVertragSchema);

export const gapSchema = ohneMarken(gapVertragSchema);

export type Gap = z.infer<typeof gapSchema>;

export const gapReportSchema = ohneMarken(gapReportVertragSchema);

export type GapReport = z.infer<typeof gapReportSchema>;

/** Der erwartete Rhythmus im Klartext. */
export const RHYTHMUS: Readonly<Record<string, string>> = {
  monthly: 'monatlich',
  quarterly: 'vierteljährlich',
  yearly: 'jährlich',
};

/** Warum ein Beleg nicht gebucht ist — die drei benannten Gründe. */
export const NICHTBUCHUNGSGRUND: Readonly<Record<string, string>> = {
  stufe_b_fehlt: 'Buchung von Eingangsrechnungen steht noch aus',
  konto_nicht_benannt: 'kein Aufwandskonto benannt',
  vor_zustaendigkeitsbeginn: 'vor dem Zuständigkeitsbeginn',
};

export const unbookedReportSchema = ohneMarken(unbookedReportVertragSchema);

export type UnbookedReport = z.infer<typeof unbookedReportSchema>;

export const formklassenSchema = ohneMarken(formklassenVertragSchema);

export const messzahlenSchema = ohneMarken(messzahlenVertragSchema);

export type Messzahlen = z.infer<typeof messzahlenSchema>;

export const ausbeutezahlenSchema = ohneMarken(ausbeutezahlenVertragSchema);

export const ausbeuteBerichtSchema = ohneMarken(ausbeuteBerichtVertragSchema);

export type AusbeuteBericht = z.infer<typeof ausbeuteBerichtSchema>;

export const formatReportSchema = ohneMarken(formatReportVertragSchema);

export type FormatReport = z.infer<typeof formatReportSchema>;

// --- Sachkonten und Abgleich Stufe A [V-kontmaske] --------------------------

/**
 * `GET /api/v1/kontenkatalog` — die Kategorieauswahl der Kontierungsmaske.
 *
 * **Direkt übernommen und nicht abgeschrieben**, wie schon
 * `tabellenansichtAntwortSchema` weiter unten: Der Katalogeintrag trägt
 * keinen Geldbetrag und keinen gebrandeten Typ, den die Aussengrenze anders
 * behandeln müsste als `@fameacc/contracts` — eine zweite Fassung wäre eine
 * zweite Wahrheit über dieselbe Form, ohne jede Anpassung, die sie
 * rechtfertigt.
 */
export { kontenkatalogAntwortSchema };
export type { AutomatikFunktion, KontenkatalogAntwort, KontenkatalogEintrag, KontenkatalogGruppe } from '@fameacc/contracts';

/**
 * `GET /api/v1/kontierungen/vorschlag/:bankTransactionId` — der
 * Kontierungsvorschlag (Task 7 `C-kontvorschlag`, Endpunkt-Nachtrag aus
 * Task 9 `V-kontmaske`). Ebenfalls direkt übernommen: keine Position trägt
 * hier einen Betrag (Kopfkommentar `packages/contracts/src/kontierung.ts`).
 */
export { kontierungsvorschlagAntwortSchema };
export type {
  Kontierungsvorschlag,
  KontierungsvorschlagAntwort,
  KontierungsvorschlagPosition,
  KontierungsvorschlagQuelle,
} from '@fameacc/contracts';

export { kontierungHerkunftSchema, nichtkontiertGrundSchema };
export type { KontierungHerkunft, NichtkontiertGrund } from '@fameacc/contracts';

export const kontierungPositionSchema = ohneMarken(kontierungPositionVertragSchema);

export type KontierungPosition = z.infer<typeof kontierungPositionSchema>;

export const kontierungSchema = ohneMarken(kontierungVertragSchema);

export type Kontierung = z.infer<typeof kontierungSchema>;

export const unkontierteListeSchema = ohneMarken(unkontierteListeVertragSchema);

export type UnkontierteListe = z.infer<typeof unkontierteListeSchema>;

/**
 * `GET /api/v1/kontierungen/bewegung/:bankTransactionId` — Bewegung samt
 * ihrer aktuell gültigen Kontierung, oder `kontierung: null`
 * (Endpunkt-Nachtrag, `KontierungController.bewegungsstand`).
 *
 * **Vom Vertrag abgeleitet, keine Abschrift (`DR-bewegungiban`).** Bis dahin
 * führte diese Datei eine eigene Kopie der Bewegungsform; als der Vertrag
 * `counterpartyIban` bekam, kam das Feld in der Oberfläche nie an, und der
 * Regel-Builder kreuzte den Namen statt der IBAN an (Handbuch §3.939: Eine
 * kopierte Schemaform verliert still jedes Feld, das der Vertrag später
 * bekommt). Seither kommt jedes Feld aus `bewegungsstandBewegungSchema` des
 * Vertrags; allein `amount` ist hier `betragSchema` (`z.string()`) statt des
 * gebrandeten `Money` aus `centAmount` — dieselbe Rechnung wie bei
 * `bankTransactionSchema.amount`: Die Marke existiert nur zur Kompilierzeit,
 * und die Aussengrenze zum Browser braucht sie nicht.
 */
export const bewegungsstandBewegungSchema = ohneMarken(
  bewegungsstandBewegungVertragSchema.extend({
    amount: betragSchema,
  }),
);

export type BewegungsstandBewegung = z.infer<typeof bewegungsstandBewegungSchema>;

export const kontierungAntwortSchema = ohneMarken(bewegungsstandAntwortVertragSchema);

export type KontierungAntwort = z.infer<typeof kontierungAntwortSchema>;

// --- Der Rundweg von der Eingangsrechnung zur Bewegung [W-manuellbind] -----
//
// **Hier WIRD abgeschrieben und nicht importiert**, wie bei
// `kontierungPositionSchema` oben: `amount` ist ein Geldbetrag, und die
// Aussengrenze braucht dafür `betragSchema` statt des gebrandeten `Money`,
// den `centAmount` im Vertrag liefert.

export const bewegungskandidatSchema = ohneMarken(bewegungskandidatVertragSchema);

export type Bewegungskandidat = z.infer<typeof bewegungskandidatSchema>;

export const rechnungBewegungTrefferSchema = ohneMarken(rechnungBewegungTrefferVertragSchema);

export type RechnungBewegungTreffer = z.infer<typeof rechnungBewegungTrefferSchema>;

export type BewegungsfundSicherheit = z.infer<typeof bewegungsfundSicherheitSchema>;
export type BewegungsfundGrund = z.infer<typeof bewegungsfundGrundSchema>;

export const bestehendeVerknuepfungSchema = ohneMarken(bestehendeVerknuepfungVertragSchema);

export type BestehendeVerknuepfung = z.infer<typeof bestehendeVerknuepfungSchema>;

export const rechnungBewegungAntwortSchema = ohneMarken(rechnungBewegungAntwortVertragSchema);

export type RechnungBewegungAntwort = z.infer<typeof rechnungBewegungAntwortSchema>;

export const bewegungssucheAntwortSchema = ohneMarken(bewegungssucheAntwortVertragSchema);

export type BewegungssucheAntwort = z.infer<typeof bewegungssucheAntwortSchema>;

export const teilzahlungBewegungSchema = ohneMarken(teilzahlungBewegungVertragSchema);

export type TeilzahlungBewegung = z.infer<typeof teilzahlungBewegungSchema>;

export const teilzahlungListeSchema = ohneMarken(teilzahlungListeVertragSchema);

export type TeilzahlungListe = z.infer<typeof teilzahlungListeSchema>;

export const kontierungWartendZeileSchema = ohneMarken(kontierungWartendZeileVertragSchema);

export type KontierungWartendZeile = z.infer<typeof kontierungWartendZeileSchema>;

export const kontierungWartendListeSchema = ohneMarken(kontierungWartendListeVertragSchema);

export const kontierungAutomatischZeileSchema = ohneMarken(kontierungAutomatischZeileVertragSchema);

export type KontierungAutomatischZeile = z.infer<typeof kontierungAutomatischZeileSchema>;

/**
 * Wie eine Zeile der Nachschau ihre Urheberin nennt — eine Code-Regel über
 * ihre Kennung, eine Datenregel über ihren Namen.
 *
 * **Eine Funktion und keine zwei Stellen mit demselben `??`.** Die Klärliste
 * zeigt die Auskunft zweimal (Zeilenmarke und Detailfeld); zwei Abschriften
 * wären zwei Gelegenheiten, die Datenregel zu vergessen und ein leeres Feld
 * anzuzeigen.
 */
export function automatischUrheberin(zeile: KontierungAutomatischZeile): string {
  return zeile.regel ?? zeile.regelName ?? 'Datenregel';
}

export const kontierungAutomatischListeSchema = ohneMarken(kontierungAutomatischListeVertragSchema);

export type KontierungAutomatischListe = z.infer<typeof kontierungAutomatischListeSchema>;

export type KontierungWartendListe = z.infer<typeof kontierungWartendListeSchema>;

/**
 * Die Antwort der Endpunkte unter `/me/tabellenansicht/:tabelle`.
 *
 * **Das Ansichtsschema wird IMPORTIERT und nicht abgeschrieben.**
 * `tabellenansichtSchema` steht in `@fameacc/contracts` und ist dieselbe Form,
 * die die API beim `PUT` prüft; eine zweite Fassung hier wäre die Stelle, an
 * der ein neuer Operator auf einer Seite ankommt und auf der anderen nicht.
 *
 * `null` ist der Normalfall und kein Fehler: Ein Benutzer, der noch nie etwas
 * eingestellt hat, hat keine Zeile.
 */
export const tabellenansichtAntwortSchema = ohneMarken(tabellenansichtAntwortVertragSchema);

/**
 * Die Antwort desselben Endpunkts unter der Tabellenkennung
 * `sachkonto-auswahl` — Sachkonto-Präferenzen (Favoriten, zuletzt verwendet)
 * statt Spaltenansicht, Chip `V-favoritenpersist`. Zwei Antwortschemata für
 * denselben Pfad, weil der Vertrag selbst zwei Äste kennt
 * (`schemaFuerTabelle()`, `@fameacc/contracts`) — welcher gilt, entscheidet
 * die aufrufende Seite über die Tabellenkennung im Pfad, nicht dieses Schema.
 */
export const sachkontoPraeferenzenAntwortSchema = ohneMarken(sachkontoPraeferenzenAntwortVertragSchema);

/**
 * Die Antwort von `GET /system/status`.
 *
 * **Die vier Lagen sind eine geschlossene Liste, und `unbekannt` gehört
 * dazu.** Ein Wert, den dieses Schema nicht kennt, lässt die ganze Antwort
 * durchfallen — das ist beabsichtigt: Eine Statusseite, die einen
 * unverstandenen Zustand als leere Zelle zeichnet, sagt «alles in Ordnung»,
 * wo sie nichts weiss.
 *
 * **Kein Enum aus `@fameacc/contracts`**, weil es dort keines gibt: Der Status
 * ist eine Auskunft der Oberfläche über den Betrieb und keine Fachanfrage, die
 * auch ein Aufrufer ohne HTTP stellte.
 */
// Web-only: `@fameacc/contracts` hat keinen Vertrag für den Betriebszustand — es
// gibt keine Fachanfrage, die eine Lage entgegennimmt oder zurückgibt. Sie ist
// eine Auskunft der HTTP-Schicht über sich selbst, dieselbe Lage wie bei
// `stageSchema` oben.
// eslint-disable-next-line no-restricted-syntax -- kein Vertragsgegenstück, siehe Kommentar oben
export const lageSchema = z.enum(['gruen', 'gelb', 'rot', 'unbekannt']);
export type Lage = z.infer<typeof lageSchema>;

export const fassungLageSchema = ohneMarken(fassungLageVertragSchema);

export type FassungLage = z.infer<typeof fassungLageSchema>;

/**
 * Die Stufe der EU-B2C-Schwelle (§ 3a Abs. 5 UStG) — importiert aus
 * `@fameacc/contracts` und nicht abgeschrieben (`no-restricted-syntax`,
 * Auftrag `ST-osswaechter`, 2026-09-05).
 */
export type EuB2cStufe = z.infer<typeof euB2cStufeSchema>;

export const euB2cSchwelleSchema = ohneMarken(euB2cSchwelleVertragSchema);
export type EuB2cSchwelle = z.infer<typeof euB2cSchwelleSchema>;

/**
 * Der Zustand einer Geheimnisform — importiert aus `@fameacc/contracts` und
 * nicht abgeschrieben (`no-restricted-syntax`, Auftrag `I-geheimnisform`,
 * 2026-09-12).
 */
export type GeheimnisformZustand = z.infer<typeof geheimnisformZustandSchema>;
export type Geheimnisform = z.infer<typeof geheimnisformSchema>;

export const systemStatusSchema = ohneMarken(systemStatusVertragSchema);

export type SystemStatus = z.infer<typeof systemStatusSchema>;
export type SystemDienst = SystemStatus['dienste'][number];
export type SystemJob = SystemStatus['jobs'][number];

export const regelZaehlungSchema = ohneMarken(regelZaehlungVertragSchema);

export type RegelZaehlung = z.infer<typeof regelZaehlungSchema>;

export const regelUebersichtZeileSchema = ohneMarken(regelUebersichtZeileVertragSchema);

export type RegelUebersichtZeile = z.infer<typeof regelUebersichtZeileSchema>;

export const regelUebersichtSchema = ohneMarken(regelUebersichtVertragSchema);

export type RegelUebersicht = z.infer<typeof regelUebersichtSchema>;

// --- Datenregeln-Liste [R-drliste] ------------------------------------------

export const datenregelFassungZeileSchema = ohneMarken(datenregelFassungZeileVertragSchema);

export type DatenregelFassungZeile = z.infer<typeof datenregelFassungZeileSchema>;

export const datenregelZeileSchema = ohneMarken(datenregelZeileVertragSchema);

export type DatenregelZeile = z.infer<typeof datenregelZeileSchema>;

export const datenregelnListeSchema = ohneMarken(datenregelnListeVertragSchema);

export type DatenregelnListe = z.infer<typeof datenregelnListeSchema>;

// --- Datenregeln: Vorschau, Vorlagen, Buchungsvorschau [R-drmaske, DR-builderui] ---

/**
 * Die Antwort von `POST /api/v1/datenregeln/vorschau` — die Live-Vorschau
 * und seit `DR-builderui` (2026-10-15, Spec 17.4) die Trefferprobe mit
 * `aufteilung` und `stand` je Treffer.
 *
 * **Aus dem Vertragspaket und nicht mehr abgeschrieben.** Bis `DR-builderui`
 * stand hier eine eigene, nicht strikte Abschrift; sie hätte `aufteilung`
 * und `stand` beim Lesen still verworfen, und die Maske hätte eine
 * Aufteilung nie zu sehen bekommen, die der Dienst längst liefert. Die
 * Kollisionswerte (`art`, `grund`) kamen schon vorher von dort.
 *
 * Dasselbe gilt für die Vorlagenliste (`GET /api/v1/datenregeln/vorlagen`)
 * und die Buchungsvorschau (`POST /api/v1/datenregeln/buchungsvorschau`):
 * eine Form, eine Stelle.
 */
export {
  datenregelVorschauAntwortSchema,
  datenregelVorlagenListeSchema,
  datenregelBuchungsvorschauAntwortSchema,
};
export type {
  DatenregelVorschauAntwort,
  DatenregelVorschauTreffer,
  DatenregelKollision,
  DatenregelAufteilung,
  DatenregelTrefferstand,
  DatenregelVorlagenEintrag,
  DatenregelVorlagenListe,
  DatenregelBuchungsvorschauAntwort,
  DatenregelBuchungszeile,
} from '@fameacc/contracts';

// --- Datenregeln: Regelsatz exportieren und importieren [DR-regelsatzui] ---

/**
 * Export, Trockenlauf und Übernahme eines Regelsatzes (`DR-regelsatzui`,
 * 2026-10-16, Spec 17.5): Format, Rümpfe und Antworten kommen aus dem
 * Vertragspaket und werden hier nicht abgeschrieben. Eine zweite Aufzählung
 * der Befunde bliebe stehen, wenn der Dienst einen siebten nennt, und die
 * Tabelle des Trockenlaufs zeigte ihn nie.
 */
export {
  DATENREGEL_IMPORT_BEFUNDE,
  DATENREGEL_SATZ_FEHLER,
  DATENREGEL_SATZ_MAX_REGELN,
  datenregelExportSchema,
  datenregelImportAntwortSchema,
  datenregelImportBefundSchema,
  datenregelImportDateiSchema,
  datenregelImportEntscheidungSchema,
  datenregelImportProbeAntwortSchema,
  datenregelImportProbeSchema,
  datenregelImportSchema,
  datenregelSatzFehlercode,
  datenregelSatzSchema,
} from '@fameacc/contracts';
export type {
  DatenregelExportRoh,
  DatenregelImportAntwort,
  DatenregelImportBefund,
  DatenregelImportDatei,
  DatenregelImportEntscheidung,
  DatenregelImportProbeAntwort,
  DatenregelImportProbeRoh,
  DatenregelImportRegelbefund,
  DatenregelImportRoh,
  DatenregelSatz,
  DatenregelSatzForm,
} from '@fameacc/contracts';

export const datenregelFassungAntwortSchema = ohneMarken(datenregelFassungAntwortVertragSchema);

export type DatenregelFassungAntwort = z.infer<typeof datenregelFassungAntwortSchema>;

// --- Startkennzahlen [V-startkennzahlen] ------------------------------------

export const startkennzahlenZeitraumSchema = ohneMarken(startkennzahlenZeitraumVertragSchema);

export type StartkennzahlenZeitraum = z.infer<typeof startkennzahlenZeitraumSchema>;

export const startkennzahlenBerichtSchema = ohneMarken(startkennzahlenBerichtVertragSchema);

export type StartkennzahlenBericht = z.infer<typeof startkennzahlenBerichtSchema>;

// --- Zuordnungsquote [F-dashquote] ------------------------------------------

export const zuordnungsquoteBerichtSchema = ohneMarken(zuordnungsquoteBerichtVertragSchema);

export type ZuordnungsquoteBericht = z.infer<typeof zuordnungsquoteBerichtSchema>;

// --- Guthabenabstimmung, LESEND [W-abstimmansicht] --------------------------
//
// Die Lese-Verträge aus `guthaben.ts` in `@fameacc/contracts`
// (`guthabenAbstimmungListSchema`/`guthabenAbstimmungDetailSchema`). Wie bei
// `customerListSchema`/`customerDetailSchema`: die Liste knapp (Kennzahlen,
// mit denen ein Anwender einen Satz erkennt), das Detail vollständig
// (`befunde`, `gleichung1`). Die beiden Aufzählungsfelder — `klasse` und
// `position` — werden aus dem Vertrag IMPORTIERT und nicht abgeschrieben,
// aus demselben Grund wie am Kopf dieser Datei erklärt: Eine sechste
// Befundklasse oder eine sechste Gleichung-1-Position ist damit automatisch
// auch hier bekannt.

export type GuthabenAbstimmungBefundklasse = z.infer<typeof guthabenAbstimmungBefundklasseSchema>;

export const guthabenAbstimmungBefundSchema = ohneMarken(guthabenAbstimmungBefundVertragSchema);

export type GuthabenAbstimmungBefund = z.infer<typeof guthabenAbstimmungBefundSchema>;

export const gleichung1KomponenteSchema = ohneMarken(gleichung1KomponenteVertragSchema);

export type Gleichung1Komponente = z.infer<typeof gleichung1KomponenteSchema>;

export const gleichung1BerichtSchema = ohneMarken(gleichung1BerichtVertragSchema);

export type Gleichung1Bericht = z.infer<typeof gleichung1BerichtSchema>;

export const guthabenAbstimmungListItemSchema = ohneMarken(guthabenAbstimmungListItemVertragSchema);

export type GuthabenAbstimmungListItem = z.infer<typeof guthabenAbstimmungListItemSchema>;

export const guthabenAbstimmungListSchema = ohneMarken(guthabenAbstimmungListeVertragSchema);

export const guthabenAbstimmungDetailSchema = ohneMarken(guthabenAbstimmungDetailVertragSchema);

export type GuthabenAbstimmungDetail = z.infer<typeof guthabenAbstimmungDetailSchema>;

// --- Guthaben-Einlösung [W-belegbezahlt] -------------------------------------
//
// Die Verträge aus `guthaben.ts`: `guthabenEinloesungSchema` in
// `@fameacc/contracts` — die Antwort von `POST /api/v1/guthaben/einloesungen`,
// mit der `documents/EinloesungDialog.tsx` eine bereits ausgestellte Rechnung
// direkt aus dem Kundenguthaben bezahlt.

export const guthabenEinloesungSchema = ohneMarken(guthabenEinloesungVertragSchema);

export type GuthabenEinloesung = z.infer<typeof guthabenEinloesungSchema>;

// --- Guthaben-Einlösungsstorno [C-einloesungsstorno] -------------------------
//
// Die Verträge aus `guthaben.ts`: `guthabenEinloesungStornoSchema` in
// `@fameacc/contracts` — die Antwort von
// `POST /api/v1/guthaben/einloesungen/:journalEntryId/storno`.

export const guthabenEinloesungStornoSchema = ohneMarken(guthabenEinloesungStornoVertragSchema);

export type GuthabenEinloesungStorno = z.infer<typeof guthabenEinloesungStornoSchema>;

// --- Guthaben-Erstattung [V-guthabenauszahlung] ------------------------------
//
// Die Erstattungs-Verträge aus `guthaben.ts` in `@fameacc/contracts`
// (`guthabenErstattungSchema`/`guthabenErstattungWartendListSchema`). Zahlweg
// und Status werden aus dem Vertrag IMPORTIERT, aus demselben Grund wie
// `guthabenAbstimmungBefundklasseSchema` oben: ein künftiger vierter Zahlweg
// oder ein dritter Status ist damit automatisch auch hier bekannt.

export type GuthabenErstattungZahlweg = z.infer<typeof guthabenErstattungZahlwegSchema>;
export type GuthabenErstattungStatus = z.infer<typeof guthabenErstattungStatusSchema>;

export const guthabenErstattungSchema = ohneMarken(guthabenErstattungVertragSchema);

export type GuthabenErstattung = z.infer<typeof guthabenErstattungSchema>;

/** `GET /api/v1/guthaben/erstattungen/wartend` — der Arbeitsvorrat der Freigabe. */
export const guthabenErstattungWartendListSchema = ohneMarken(guthabenErstattungWartendListeVertragSchema);

/** `GET`/`PUT /api/v1/einstellungen/guthaben` — der Schalter samt Bestand (`D-57`). */
export const guthabenSchalterSchema = ohneMarken(guthabenSchalterVertragSchema);

export type GuthabenSchalter = z.infer<typeof guthabenSchalterSchema>;

// --- Guthaben-Korrektur [GU-korrekturmaske] ----------------------------------
//
// Die Korrektur-Verträge aus `guthaben.ts` in `@fameacc/contracts`
// (`guthabenKorrekturSchema`/`guthabenKorrekturListeSchema`/
// `guthabenKorrekturKetteSchema`/`guthabenKorrekturSpiegelOffenListeSchema`).
// Die fuenf Aufzaehlungsfelder — Grund, Richtung, Bezug, Spiegel, Status —
// werden aus dem Vertrag IMPORTIERT und nicht abgeschrieben, aus demselben
// Grund wie am Kopf dieser Datei erklaert: Der Grundkatalog traegt heute genau
// einen Wert (`anfangsbestand`), und ein zweiter — sobald seine Gegenseite
// entschieden ist — ist damit automatisch auch hier bekannt.
//
// **`id` und `zeileId` sind zwei verschiedene Kennungen, und das ist der
// Unterschied zur Erstattung.** `id` ist IMMER die Kennung der ANLAGE und der
// Wert, den `POST .../:id/freigabe` im Pfad erwartet; `zeileId` sagt, aus
// welcher der bis zu drei anfuegenden Zeilen der angezeigte Stand stammt. Die
// Oberflaeche darf deshalb nie `zeileId` in einen Pfad schreiben — sie liefe
// in ein `GUTHABEN_KORREKTUR_NOT_FOUND`.

export type GuthabenKorrekturGrund = z.infer<typeof guthabenKorrekturGrundSchema>;
export type GuthabenKorrekturRichtung = z.infer<typeof guthabenKorrekturRichtungSchema>;
export type GuthabenKorrekturBezug = z.infer<typeof guthabenKorrekturBezugSchema>;
export type GuthabenKorrekturSpiegel = z.infer<typeof guthabenKorrekturSpiegelSchema>;
export type GuthabenKorrekturStatus = z.infer<typeof guthabenKorrekturStatusSchema>;

export const guthabenKorrekturSchema = ohneMarken(guthabenKorrekturVertragSchema);

export type GuthabenKorrektur = z.infer<typeof guthabenKorrekturSchema>;

/** `GET /api/v1/guthaben/korrekturen` — je Vorgang ein Eintrag, nicht je Zeile. */
export const guthabenKorrekturListSchema = ohneMarken(guthabenKorrekturListeVertragSchema);

export const guthabenKorrekturKetteSchema = ohneMarken(guthabenKorrekturKetteVertragSchema);

export const guthabenKorrekturSpiegelOffenSchema = ohneMarken(guthabenKorrekturSpiegelOffenVertragSchema);

export type GuthabenKorrekturSpiegelOffen = z.infer<typeof guthabenKorrekturSpiegelOffenSchema>;

/** `GET /api/v1/guthaben/korrekturen/spiegel-offen` — der Arbeitsvorrat der Spiegelung. */
export const guthabenKorrekturSpiegelOffenListSchema = ohneMarken(guthabenKorrekturSpiegelOffenListeVertragSchema);
// --- Geldkonto-Anfangsbestand [K-geldkontenmaske] ----------------------------
//
// Die Verträge aus `kontierung/geldkonto-anfangsbestand.ts` in
// `@fameacc/contracts`. Richtung und Status werden aus dem Vertrag
// IMPORTIERT, aus demselben Grund wie bei der Guthaben-Erstattung oben; die
// übrigen Felder bleiben einfache Zeichenketten — dieselbe Bauform wie
// `guthabenErstattungSchema`.

export type GeldkontoAnfangsbestandRichtung = z.infer<
  typeof geldkontoAnfangsbestandRichtungSchema
>;
export type GeldkontoAnfangsbestandStatus = z.infer<typeof geldkontoAnfangsbestandStatusSchema>;

export const geldkontoAnfangsbestandZeileSchema = ohneMarken(geldkontoAnfangsbestandZeileVertragSchema);

export type GeldkontoAnfangsbestandZeile = z.infer<typeof geldkontoAnfangsbestandZeileSchema>;

export const geldkontoAnfangsbestandListeSchema = ohneMarken(geldkontoAnfangsbestandListeVertragSchema);

export const geldkontoAnfangsbestandFreigabeAntwortSchema = ohneMarken(geldkontoAnfangsbestandFreigabeAntwortVertragSchema);

export type GeldkontoAnfangsbestandFreigabeAntwort = z.infer<
  typeof geldkontoAnfangsbestandFreigabeAntwortSchema
>;

// --- Sachkonto-Saldenvortrag [K-saldenvortrag] ------------------------------
//
// Die Lese-Verträge aus `kontierung/sachkonto-saldenvortrag.ts` in
// `@fameacc/contracts` (Migration `0285`, `D-53`). Richtung, Status und
// Kontoart werden aus dem Vertrag IMPORTIERT, die übrigen Felder bleiben
// einfache Zeichenketten — dieselbe Bauform wie der Geldkonto-Anfangsbestand
// darüber.

export type SachkontoSaldenvortragRichtung = z.infer<typeof sachkontoSaldenvortragRichtungSchema>;
export type SachkontoSaldenvortragStatus = z.infer<typeof sachkontoSaldenvortragStatusSchema>;

export const sachkontoSaldenvortragZeileSchema = ohneMarken(sachkontoSaldenvortragZeileVertragSchema);

export type SachkontoSaldenvortragZeile = z.infer<typeof sachkontoSaldenvortragZeileSchema>;

export const sachkontoSaldenvortragKontoSchema = ohneMarken(sachkontoSaldenvortragKontoVertragSchema);

export type SachkontoSaldenvortragKonto = z.infer<typeof sachkontoSaldenvortragKontoSchema>;

export const sachkontoSaldenvortragListeSchema = ohneMarken(sachkontoSaldenvortragListeVertragSchema);

export type SachkontoSaldenvortragListe = z.infer<typeof sachkontoSaldenvortragListeSchema>;

export const sachkontoSaldenvortragAnlageAntwortSchema = ohneMarken(sachkontoSaldenvortragAnlageAntwortVertragSchema);

export type SachkontoSaldenvortragAnlageAntwort = z.infer<
  typeof sachkontoSaldenvortragAnlageAntwortSchema
>;

export const sachkontoSaldenvortragFreigabeAntwortSchema = ohneMarken(sachkontoSaldenvortragFreigabeAntwortVertragSchema);

export type SachkontoSaldenvortragFreigabeAntwort = z.infer<
  typeof sachkontoSaldenvortragFreigabeAntwortSchema
>;

/** Der Rumpf der Anlage — was die Maske schickt. */
export interface SachkontoSaldenvortragAnlageEingabe {
  readonly kontonummer: string;
  readonly richtung: SachkontoSaldenvortragRichtung;
  readonly betrag: string;
  readonly begruendung: string;
  readonly quelle: string;
}

/** Der Rumpf der Ersetzung — wie die Anlage, ohne Kontonummer (die Kette wechselt das Konto nicht). */
export interface SachkontoSaldenvortragErsetzenEingabe {
  readonly richtung: SachkontoSaldenvortragRichtung;
  readonly betrag: string;
  readonly begruendung: string;
  readonly quelle: string;
}

// --- Offene Posten und Zahlstatus [C-offeneposten] ---------------------------
//
// Plan Task 14 plus der Auftraggeberwunsch vom 2026-08-28. Die Herleitung — was
// die Ableitung sieht und was nicht — steht im Vertrag
// (`packages/contracts/src/offene-posten.ts`) und wird hier nicht wiederholt.
//
// **Die zwei Wertelisten kommen aus dem Vertrag**, nicht aus einer zweiten
// Aufzählung: `zahlstatusSchema` und `zahlwegSchema` sind importiert (siehe der
// Kopfkommentar dieser Datei zu `structured_xml`).

export const rechnungZahlungSchema = ohneMarken(rechnungZahlungVertragSchema);

export type RechnungZahlung = z.infer<typeof rechnungZahlungSchema>;

export const rechnungZahlstandSchema = ohneMarken(rechnungZahlstandVertragSchema);

export type RechnungZahlstand = z.infer<typeof rechnungZahlstandSchema>;

export const rechnungZahlstatusSchema = ohneMarken(rechnungZahlstatusVertragSchema);

export type RechnungZahlstatus = z.infer<typeof rechnungZahlstatusSchema>;

export const zahlstatusAntwortSchema = ohneMarken(zahlstatusAntwortVertragSchema);

export const zahlstatusListeSchema = ohneMarken(zahlstatusListeVertragSchema);

export const offenePostenBelegSchema = ohneMarken(offenePostenBelegVertragSchema);

export type OffenePostenBeleg = z.infer<typeof offenePostenBelegSchema>;

export const offenePostenKundeSchema = ohneMarken(offenePostenKundeVertragSchema);

export type OffenePostenKunde = z.infer<typeof offenePostenKundeSchema>;

export const offenePostenUeberfaelligSchema = ohneMarken(offenePostenUeberfaelligVertragSchema);

export type OffenePostenUeberfaellig = z.infer<typeof offenePostenUeberfaelligSchema>;

export const offenePostenBerichtSchema = ohneMarken(offenePostenBerichtVertragSchema);

export type OffenePostenBericht = z.infer<typeof offenePostenBerichtSchema>;

// --- Offene Verbindlichkeiten [V-kreditorposten] -----------------------------
//
// Der Zwilling der Offene-Posten-Ableitung auf der Lieferantenseite, Auftrag
// `V-kreditorposten` (2026-09-02). Die Herleitung — warum die Verbindlichkeit
// als einzige Zahl NICHT aus dem Journal kommt — steht im Vertrag
// (`packages/contracts/src/offene-verbindlichkeiten.ts`) und wird hier nicht
// wiederholt.
//
// **`zahlstatusSchema` und `zahlwegSchema` sind dieselben Wertelisten** wie auf
// der Forderungsseite, importiert und nicht ein zweites Mal aufgezählt.

export const verbindlichkeitZahlungSchema = ohneMarken(verbindlichkeitZahlungVertragSchema);

export type VerbindlichkeitZahlung = z.infer<typeof verbindlichkeitZahlungSchema>;

export const eingangsrechnungZahlstandSchema = ohneMarken(eingangsrechnungZahlstandVertragSchema);

export type EingangsrechnungZahlstand = z.infer<typeof eingangsrechnungZahlstandSchema>;

export const eingangsrechnungZahlstatusSchema = ohneMarken(eingangsrechnungZahlstatusVertragSchema);

export type EingangsrechnungZahlstatus = z.infer<typeof eingangsrechnungZahlstatusSchema>;

export const verbindlichkeitZahlstatusAntwortSchema = ohneMarken(verbindlichkeitZahlstatusAntwortVertragSchema);

export const verbindlichkeitZahlstatusListeSchema = ohneMarken(verbindlichkeitZahlstatusListeVertragSchema);

/** Die Beschriftung eines Zahlstatus. */
export const ZAHLSTATUS: Readonly<Record<RechnungZahlstand['status'], string>> = {
  offen: 'Offen',
  teilbezahlt: 'Teilbezahlt',
  bezahlt: 'Bezahlt',
};

/**
 * Die Beschriftung eines Zahlwegs.
 *
 * `ueberweisung` und nicht „FinTS": Der Abrufkanal ist nicht der Weg, auf dem
 * das Geld kam — dieselbe Übersetzung, die `berichte/zahlstatus.ts` auf der
 * Dienstseite vornimmt.
 */
export const ZAHLWEG: Readonly<Record<RechnungZahlung['zahlweg'], string>> = {
  guthaben: 'Guthaben',
  ueberweisung: 'Überweisung',
  paypal: 'PayPal',
  mollie: 'Mollie',
  storno: 'Storno',
  unbekannt: 'Unbekannt',
};

/**
 * Die Beschriftung der Mahnstufen-VORSCHAU — Mahnwesen-Spec 3.1.
 *
 * **Anzeige und kein Verfahren.** Es gibt keinen Mahnlauf, der diese Stufe
 * setzt, und keinen Beleg, der sie trägt; die Beschriftung sagt deshalb, was
 * gälte, und nicht, was ist.
 */
export const MAHNSTUFE_VORSCHAU: Readonly<Record<number, string>> = {
  0: '—',
  1: 'Zahlungserinnerung',
  2: '1. Mahnung',
  3: '2. Mahnung',
  4: 'Übergabe Inkasso',
};

// --- Auswertungen [AW-geruest] ----------------------------------------------
//
// Die gemeinsame Hülle jeder Antwort des Auswertungsmoduls — Spec
// `docs/superpowers/specs/2026-09-10-auswertungen-design.md` Abschnitt 7.3,
// `D-9`, `D-10`, `D-31`.
//
// **Der Zeitraumtyp wird IMPORTIERT und nicht nachgebaut**
// (`auswertungZeitraumTypSchema`, oben in der Importliste): Er ist im Vertrag
// aus dem Dashboard-Schema abgeleitet, und eine dritte Liste hier wäre die
// dritte Wahrheit.
//
// **Auch die Hülle ist der Vertrag**, nicht eine entspanntere Abschrift: Eine
// Antwort, die der Vertrag nicht kennt, wird als unlesbar gemeldet und nicht
// still gekürzt.

export const auswertungZeitraumSchema = ohneMarken(auswertungZeitraumVertragSchema);

export type AuswertungZeitraumAnsicht = z.infer<typeof auswertungZeitraumSchema>;

export const auswertungUnterseiteSchema = ohneMarken(auswertungUnterseiteVertragSchema);

export type AuswertungUnterseiteAnsicht = z.infer<typeof auswertungUnterseiteSchema>;

export const auswertungUeberblickSchema = ohneMarken(auswertungUeberblickVertragSchema);

export type AuswertungUeberblickAnsicht = z.infer<typeof auswertungUeberblickSchema>;

// --- Auswertungen: Zahlungswege [AW-zahlwege] --------------------------------
//
// Zwei Quellen fuer dieselbe Frage, und der Vertrag haelt sie auseinander
// (`D-20`): `gebucht` ab dem Journalbeginn aus dem Geldkonto der Buchung,
// `altbestand` fuer 2022 bis 2025 aus dem Zahlweg des Altsystems. Sie werden
// nie addiert -- die eine Seite zaehlt Rechnungsbrutto zum Rechnungsdatum,
// die andere Geldbewegung zum Buchungsdatum.
//
// **Der Anteil kommt als Zeichenkette an und bleibt eine.** Was die Seite
// damit tut, ist ihn ueber `format.ts` anzeigen, nie ihn rechnen.

export const auswertungAnteilSchema = ohneMarken(auswertungAnteilVertragSchema);

export type AuswertungAnteilAnsicht = z.infer<typeof auswertungAnteilSchema>;

export const auswertungMonatsreiheSchema = ohneMarken(auswertungMonatsreiheVertragSchema);

export type AuswertungMonatsreiheAnsicht = z.infer<typeof auswertungMonatsreiheSchema>;

export const auswertungGuthabenMonatSchema = ohneMarken(auswertungGuthabenMonatVertragSchema);

export type AuswertungGuthabenMonatAnsicht = z.infer<typeof auswertungGuthabenMonatSchema>;

export const auswertungZahlungswegeSchema = ohneMarken(auswertungZahlungswegeVertragSchema);

export type AuswertungZahlungswegeAnsicht = z.infer<typeof auswertungZahlungswegeSchema>;

// --- Auswertungen: Forderungen [AW-forderungen] ------------------------------
//
// Eine Altersstruktur und ein Mahnstand, der nicht dieser ist (`D-29`): Es
// gibt kein Mahnwesen in diesem System, und was hier ankommt, ist die Angabe,
// die der Altimport an den Altbelegen mitgebracht hat. Deshalb heisst das
// Feld `mahnstandAltbestand` und nicht `mahnwesen`, und deshalb gibt es
// nirgends eine Quote.

export const auswertungAltersbandSchema = ohneMarken(auswertungAltersbandVertragSchema);

export type AuswertungAltersbandAnsicht = z.infer<typeof auswertungAltersbandSchema>;

export const auswertungForderungenSchema = ohneMarken(auswertungForderungenVertragSchema);

export type AuswertungForderungenAnsicht = z.infer<typeof auswertungForderungenSchema>;

// --- Kundenportal: die Arbeitsliste der Portal-Vorgänge [KP-oberflaeche] -----
//
// `GET /api/v1/portal-vorgaenge?status=offen|erledigt` und
// `POST /api/v1/portal-vorgaenge/:id/erledigen` (Spec Kundenportal Abschnitt
// 6, Betrieb-Tabelle; Fähigkeiten `document:read` beziehungsweise
// `document:manage`).
//
// DER EINTRAG KOMMT AUS DEM VERTRAG, DER UMSCHLAG STEHT HIER. `portalVorgangSchema`
// (`packages/contracts/src/portal.ts`) ist die eine Form einer Zeile — sie wird
// nicht abgeschrieben, weil sie keinen Geldbetrag trägt, den die Aussengrenze
// anders behandeln müsste (dieselbe Rechnung wie bei
// `kontenkatalogAntwortSchema` oben). Der Umschlag dagegen steht hier und nicht
// im Vertrag, wie bei den meisten Listen dieser Oberfläche: `pnpm
// listen:vertrag` prüft die echte Antwort gegen GENAU dieses Schema, weil es
// dasjenige ist, das `apps/web/src/api/client.ts` beim Aufruf benutzt.
//
// NAHT ZU TASK 4 (`KP-kunde`): Der Dienst, der diese zwei Routen baut, antwortet
// gegen diese zwei Formen — `{ vorgaenge: [...] }` für die Liste, die
// aktualisierte Zeile für das Erledigen. Beides ist hier benannt, damit der
// Zweig, der die Routen bringt, nichts erfinden muss.

export { portalVorgangSchema };
export type {
  PortalVorgang,
  PortalVorgangArt,
  PortalVorgangInhalt,
  PortalRueckfrageInhalt,
  PortalAenderungsantragInhalt,
} from '@fameacc/contracts';

/**
 * `GET /api/v1/portal-vorgaenge` — die Arbeitsliste, neueste zuerst.
 *
 * **Aus dem Vertrag re-exportiert und nicht hier nachgebaut.** Task 4
 * (`KP-kunde`) führt den Umschlag in `packages/contracts/src/portal.ts`, und
 * zwar `.strict()`: Ein Feld, das die Antwort zusätzlich trüge, fiele dort auf
 * statt stillschweigend gestrichen zu werden. Ein zweites `z.object` hier wäre
 * genau die Fehlerklasse aus `docs/HANDBOOK.md` 3.663 — ein Spiegel, der ein
 * Vertragsfeld nicht nennt, streicht es beim Lesen ohne Fehler.
 */
export { portalVorgangListeSchema } from '@fameacc/contracts';
export type { PortalVorgangListe } from '@fameacc/contracts';

// ---------------------------------------------------------------------------
// Vorsystem — Einrichtungsschritt (LX-einrichtungsschritt)
//
// Der Auftrag trägt sein Ergebnis als offenes Objekt (`vorsystemAuftragSchema`,
// `ergebnis: record`): Es ist die maschinenlesbare Ausgabe des Läufers und
// wächst mit ihm. Die Oberfläche liest daraus genau das, was sie anzeigt, und
// nichts darüber hinaus; was sich nicht lesen lässt, zeigt sie als «Das Ergebnis
// liess sich nicht lesen» und nicht als Erfolg.
// ---------------------------------------------------------------------------

/**
 * Der Zwischenstand eines Auftrags (`E-1992`): die Form kommt aus dem Vertrag und wird hier nicht
 * abgeschrieben — eine Kopie würde die Felder verlieren, die der Vertrag später bekommt (Handbuch §3.939).
 */
export { vorsystemFortschrittSchema };
export type { VorsystemFortschritt } from '@fameacc/contracts';

/** Das Urteil einer Verbindungsprüfung (Spec 20.5), samt Kontenrahmen, falls das Profil ihn nennt. */
export const vorsystemVerbindungErgebnisSchema = z
  .object({
    // Eine Zeichenkette und keine Aufzählung: Die Urteile gehören der Schiene, und ein Urteil, das die
    // Oberfläche nicht kennt, soll als «nicht lesbar» enden (`verbindungSatz()`), nicht am Schema scheitern.
    urteil: z.string(),
    kontenrahmen: z.string().nullish(),
  })
  .passthrough();
export type VorsystemVerbindungErgebnis = z.infer<typeof vorsystemVerbindungErgebnisSchema>;

/** Das Ergebnis der Kollisionsprüfung `anschluss`: je Belegkreis die erste eigene und die letzte Nummer im Vorsystem. */
export const vorsystemAnschlussErgebnisSchema = z
  .object({
    ergebnis: z.string().optional(),
    meldung: z.string().nullish(),
    daten: z
      .object({
        kreise: z.array(
          z
            .object({
              rangeKey: z.string(),
              ersteEigeneNummer: z.string(),
              letzteLexwareNummer: z.string().nullable(),
              voraus: z.number(),
              kollidiert: z.boolean(),
            })
            .passthrough(),
        ),
      })
      .passthrough(),
  })
  .passthrough();
export type VorsystemAnschlussErgebnis = z.infer<typeof vorsystemAnschlussErgebnisSchema>;

/** Das Ergebnis der Vorprüfung `pruefen`: Urteil und Meldung; die Befunde kommen aus `GET /vorsystem/befunde`. */
export const vorsystemLaufErgebnisSchema = z
  .object({
    ergebnis: z.string(),
    meldung: z.string().nullish(),
  })
  .passthrough();
export type VorsystemLaufErgebnis = z.infer<typeof vorsystemLaufErgebnisSchema>;
